import { Blog } from '../../model/blog/blog.model';

// AUTO-GENERATED by scripts/generate-blog.js - do not edit by hand.
// Source: src/content/blog/*.md   |   Regenerate: npm run blog
export const BLOG: Blog[] = [
  {
    "key": "anatomy-of-the-dublin-theme",
    "url": "/blog/anatomy-of-the-dublin-theme",
    "title": "Anatomy of a Light Theme: Dublin",
    "excerpt": "Anatomy of Dublin, a light IDE theme: a park green frame around a white page, tricolour green keywords, shamrock strings and autumn orange members.",
    "date": "2026-10-19",
    "dateLabel": "October 19, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "dublin",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "tricolour"
    ],
    "readingTimeMinutes": 10,
    "cover": "/assets/blog/anatomy-of-the-dublin-theme/cover.webp",
    "icon": "/assets/themes/cities/dublin-theme/icon.webp",
    "coverAccent": "#169B62",
    "relatedThemes": [
      "dublin"
    ],
    "relatedPlatform": "",
    "relatedColor": "169B62",
    "relatedPalette": "F1F9F3-6CC682-169B62-1F9140-E26B03-BD7135",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": null,
    "next": {
      "key": "anatomy-of-the-london-theme",
      "title": "Anatomy of a Dark Theme: London",
      "url": "/blog/anatomy-of-the-london-theme",
      "cover": "/assets/blog/anatomy-of-the-london-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Dublin theme?",
        "a": "Dublin is one of Codigrate's premium light city themes, built around Dublin on a bright autumn morning: the round tower of Dublin Castle over a green lawn, with the trees around it turning orange. The frame of the editor is a park green, the code is written on an almost white page with a breath of green in it, and the syntax is the lawn and the trees: tricolour green keywords, shamrock strings and numbers, and autumn oranges and browns for the fields, methods, tags and the rest of an object."
      },
      {
        "q": "Why is the frame of Dublin so green?",
        "a": "Because the city is named after a garden, in a way. Dublin comes from Dubh Linn, the black pool, and the place where that pool once lay is now a round lawn behind Dublin Castle. The outer frame of the theme is Castle Sky #6CC682, a real mid green at 60 percent lightness, the panels are Liffey Mist #D3F3DB and the editor Ha'penny White #F1F9F3. All three sit on the same hue, 135 degrees, so the window reads as one park and the page in the middle as the brightest part of it."
      },
      {
        "q": "How are the syntax colors chosen in Dublin?",
        "a": "They follow the Irish tricolour: green, white and orange. The page is the white. The greens, between 137 and 154 degrees, carry the structure and the values: tricolour green keywords in bold and shamrock green strings and numbers. The oranges and browns, between 26 and 44 degrees, carry everything that belongs to an object or a document: autumn haze fields and methods, copper leaf static members, tricolour orange tags, and coffee and turf browns for parameters, attributes and globals. Local variables and comments stay close to grey."
      },
      {
        "q": "Where can I get the Dublin theme?",
        "a": "Dublin is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Xcode, Zed, Sublime Text, Ghostty, iTerm2, macOS Terminal, Claude Code, Slack, Rhino and Firefox it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Dublin theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-london-theme",
    "url": "/blog/anatomy-of-the-london-theme",
    "title": "Anatomy of a Dark Theme: London",
    "excerpt": "Anatomy of London, a dark IDE theme: dusk slate and twilight indigo for the frame, kiosk red keywords, Thames steel members and strings in fog grey.",
    "date": "2026-10-18",
    "dateLabel": "October 18, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "london",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "telephone box"
    ],
    "readingTimeMinutes": 10,
    "cover": "/assets/blog/anatomy-of-the-london-theme/cover.webp",
    "icon": "/assets/themes/cities/london-theme/icon.webp",
    "coverAccent": "#EE4B5B",
    "relatedThemes": [
      "london"
    ],
    "relatedPlatform": "",
    "relatedColor": "EE4B5B",
    "relatedPalette": "201F29-3B3A45-EE4B5B-E88790-7FA3C6-DDDFEA",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-dublin-theme",
      "title": "Anatomy of a Light Theme: Dublin",
      "url": "/blog/anatomy-of-the-dublin-theme",
      "cover": "/assets/blog/anatomy-of-the-dublin-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-fuji-theme",
      "title": "Anatomy of a Light Theme: Fuji",
      "url": "/blog/anatomy-of-the-fuji-theme",
      "cover": "/assets/blog/anatomy-of-the-fuji-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the London theme?",
        "a": "London is one of Codigrate's premium dark city themes, built around London at dusk: wet pavements, Portland stone going grey in the last light, the Thames the color of steel and a red telephone box glowing on the corner. The frame of the editor is slate grey with a wash of twilight indigo, and the code is written on a dusk slate almost black. The syntax is the street: kiosk red keywords, rose globals and tags, Thames steel fields and methods, mist blue local variables and strings in the grey of a London fog."
      },
      {
        "q": "Why is London so grey?",
        "a": "Because the city is, after the sun goes down. Every background sits between 245 and 251 degrees on the wheel, a blue violet, at 9 to 14 percent saturation, so it reads as grey with a little evening in it. The input fields sit on coal ink #17161D, the editor on dusk slate #201F29, the panels on fog indigo #2D2B36 and the outer frame on Portland shadow #3B3A45, each a few steps lighter than the one inside it. With the frame that quiet, the red of a keyword stands out the way a telephone box does on a grey street."
      },
      {
        "q": "How are the syntax colors chosen in London?",
        "a": "They come in two families. The reds are the street furniture: keywords in kiosk red at 354 degrees, globals in a brick rose, tags in a post box rose and attributes in a clay brick. The blues are the river and the sky: fields and methods in Thames steel at 210 degrees, static members in a deeper steel blue, local variables in mist blue, parameters in chalk blue, and strings and numbers in fog grey. Nearly all the code is the cool family, so the red lands on the words that shape a file."
      },
      {
        "q": "Where can I get the London theme?",
        "a": "London is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Xcode, Zed, Sublime Text, Ghostty, iTerm2, macOS Terminal, Claude Code, Slack, Rhino and Firefox it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the London theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-fuji-theme",
    "url": "/blog/anatomy-of-the-fuji-theme",
    "title": "Anatomy of a Light Theme: Fuji",
    "excerpt": "Anatomy of Fuji, a light IDE theme: dawn peach and snow white for the frame, sakura rose keywords, mauve plum values and teal members, Mount Fuji at sunrise.",
    "date": "2026-10-17",
    "dateLabel": "October 17, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "fuji",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "mount fuji"
    ],
    "readingTimeMinutes": 10,
    "cover": "/assets/blog/anatomy-of-the-fuji-theme/cover.webp",
    "icon": "/assets/themes/nature/fuji-theme/icon.webp",
    "coverAccent": "#DD747A",
    "relatedThemes": [
      "fuji"
    ],
    "relatedPlatform": "",
    "relatedColor": "DD747A",
    "relatedPalette": "FFFCFB-F5D9D0-DD747A-BF8AB3-39A1A5-DC5B26",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-london-theme",
      "title": "Anatomy of a Dark Theme: London",
      "url": "/blog/anatomy-of-the-london-theme",
      "cover": "/assets/blog/anatomy-of-the-london-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-etna-theme",
      "title": "Anatomy of a Dark Theme: Etna",
      "url": "/blog/anatomy-of-the-etna-theme",
      "cover": "/assets/blog/anatomy-of-the-etna-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Fuji theme?",
        "a": "Fuji is one of Codigrate's premium light nature themes, built around Mount Fuji at first light: the snowcap turning pink in the sunrise, cherry trees in bloom below it and a vermilion torii by the lake. The frame of the editor is the dawn, a soft coral peach, and the code is written on a snow white page. The syntax is the blossom and the lake: sakura rose keywords, mauve plum strings and numbers, dusty rose parameters, with Fuji teal fields and methods and slate blue local variables for the cool notes."
      },
      {
        "q": "Why is everything in Fuji tinted peach?",
        "a": "Because that is what snow does at sunrise. Every background in Fuji shares one hue, between 15 and 18 degrees on the wheel: the outer frame is Dawn Peach #F5D9D0, the panels Petal Mist #FBEAE3 and the editor Snow White #FFFCFB, almost white at 99 percent lightness. The color gets stronger the further it is from the code, so the window glows around the edge like a snowfield in the first sun, and the page in the middle stays clean and bright."
      },
      {
        "q": "How are the syntax colors chosen in Fuji?",
        "a": "They split the view into the warm side and the cool side. The warm side is the dawn and the blossom: keywords, globals and tags in sakura rose at 357 degrees, parameters in dusty rose at 338, strings and numbers in mauve plum at 314 and static members in terracotta at 14. The cool side is the lake and the shadow on the snow: fields and methods in Fuji teal at 182 and local variables in slate blue at 212. The two sides sit almost opposite each other on the wheel, so the teal members are easy to find in a pink file."
      },
      {
        "q": "Where can I get the Fuji theme?",
        "a": "Fuji is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Xcode, Zed, Sublime Text, Ghostty, iTerm2, macOS Terminal, Claude Code, Slack, Rhino and Firefox it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Fuji theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-etna-theme",
    "url": "/blog/anatomy-of-the-etna-theme",
    "title": "Anatomy of a Dark Theme: Etna",
    "excerpt": "Anatomy of Etna, a dark IDE theme: basalt and volcanic ash for the frame, lava rose keywords, sulfur gold members and strings the grey of fresh ash.",
    "date": "2026-10-16",
    "dateLabel": "October 16, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "etna",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "volcano"
    ],
    "readingTimeMinutes": 10,
    "cover": "/assets/blog/anatomy-of-the-etna-theme/cover.webp",
    "icon": "/assets/themes/nature/etna-theme/icon.webp",
    "coverAccent": "#D74C57",
    "relatedThemes": [
      "etna"
    ],
    "relatedPlatform": "",
    "relatedColor": "D74C57",
    "relatedPalette": "121111-222121-E3636C-E8C259-D74C57-E19060",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-fuji-theme",
      "title": "Anatomy of a Light Theme: Fuji",
      "url": "/blog/anatomy-of-the-fuji-theme",
      "cover": "/assets/blog/anatomy-of-the-fuji-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-madrid-theme",
      "title": "Anatomy of a Light Theme: Madrid",
      "url": "/blog/anatomy-of-the-madrid-theme",
      "cover": "/assets/blog/anatomy-of-the-madrid-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Etna theme?",
        "a": "Etna is one of Codigrate's premium dark nature themes, built around Mount Etna on a night when it is erupting: black basalt slopes, a glowing crater and embers drifting over the lava fields. The frame of the editor is ash and basalt, greys with almost no color in them, and the code is written on a volcanic ash black. The syntax is the lava: lava rose keywords, ember coral globals, orange static members and sulfur gold fields, methods and parameters, with strings and numbers left the pale grey of fresh ash."
      },
      {
        "q": "Why are the backgrounds in Etna almost colorless?",
        "a": "Because on the mountain at night the rock is black and only the lava glows. The input fields sit on obsidian #080808, the editor on volcanic ash #121111, the panels on basalt grey #1E1D1D and the outer frame on ash stone #222121, all between 3 and 13 percent lightness and all with a saturation of 3 percent or less. With the frame that quiet, every warm color in the theme reads as heat, and there is only one red background in the whole window: the ember bed #3F171A behind the active tab."
      },
      {
        "q": "How are the syntax colors chosen in Etna?",
        "a": "They follow the colors of hot rock. Keywords are the deepest red, a lava rose at 356 degrees, and the syntax climbs from there toward yellow the way glowing lava does as it gets hotter: ember coral globals at 8 degrees, orange static members at 22, annotations and local variables between 32 and 34, sulfur parameters at 40 and gold fields and methods at 44. That is an analogous harmony across about fifty degrees of the wheel. Strings and numbers step out of it on purpose and take an ash grey, so the values in a file look like what the mountain throws out rather than what flows from it."
      },
      {
        "q": "Where can I get the Etna theme?",
        "a": "Etna is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Xcode, Zed, Sublime Text, Ghostty, iTerm2, macOS Terminal, Claude Code, Slack, Rhino and Firefox it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Etna theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-madrid-theme",
    "url": "/blog/anatomy-of-the-madrid-theme",
    "title": "Anatomy of a Light Theme: Madrid",
    "excerpt": "Anatomy of Madrid, a light IDE theme: a saffron frame around a page of sunlit limestone, sangria keywords, flamenco red values and azulejo blue comments.",
    "date": "2026-10-15",
    "dateLabel": "October 15, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "madrid",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "carnation"
    ],
    "readingTimeMinutes": 9,
    "cover": "/assets/blog/anatomy-of-the-madrid-theme/cover.webp",
    "icon": "/assets/themes/cities/madrid-theme/icon.webp",
    "coverAccent": "#B84440",
    "relatedThemes": [
      "madrid"
    ],
    "relatedPlatform": "",
    "relatedColor": "B84440",
    "relatedPalette": "FBFAF2-E8C25D-B84440-BD503F-A57F02-349590",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-etna-theme",
      "title": "Anatomy of a Dark Theme: Etna",
      "url": "/blog/anatomy-of-the-etna-theme",
      "cover": "/assets/blog/anatomy-of-the-etna-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-vienna-theme",
      "title": "Anatomy of a Dark Theme: Vienna",
      "url": "/blog/anatomy-of-the-vienna-theme",
      "cover": "/assets/blog/anatomy-of-the-vienna-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Madrid theme?",
        "a": "Madrid is one of Codigrate's premium light city themes, built around a Madrid balcony in summer: sunlit limestone, saffron walls and carnations in pots along the railing. The frame of the editor is a saffron gold, the page the code is written on is a warm limestone white, and the syntax is the flowers on the balcony: sangria keywords, flamenco red strings and numbers, Toledo gold members, with azulejo blues and an Andalusian teal for the cooler notes."
      },
      {
        "q": "Why is the frame of Madrid so much stronger than the editor?",
        "a": "Because the frame is the wall and the editor is the window in it. The outer surface is Madrid gold #E8C25D at about 64 percent lightness, the panels a pale golden morning #FDF5DF, and the editor almost white, a limestone #FBFAF2 at 97 percent lightness. All three share the same golden hue, between 44 and 53 degrees, so the window reads as one sunlit building, and the code sits on the brightest and quietest part of it."
      },
      {
        "q": "How are the syntax colors chosen in Madrid?",
        "a": "They come from two places in the city. The warm half is the balcony: keywords, strings, local variables, globals and annotations are reds and rose browns between 2 and 14 degrees on the wheel, and fields, methods and tags are golds between 41 and 46. The cool half is the tiles: comments and attributes are azulejo blues around 200 degrees, parameters an Andalusian teal at 177 and static members a park green at 133. Gold and tile blue sit almost opposite each other on the wheel, so the cool notes are easy to find in a warm file."
      },
      {
        "q": "Where can I get the Madrid theme?",
        "a": "Madrid is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Xcode, Zed, Sublime Text, Ghostty, iTerm2, macOS Terminal, Slack, Rhino and Firefox it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Madrid theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-vienna-theme",
    "url": "/blog/anatomy-of-the-vienna-theme",
    "title": "Anatomy of a Dark Theme: Vienna",
    "excerpt": "Anatomy of Vienna, a dark IDE theme: crimson velvet and mahogany for the frame, imperial gold keywords, pastry cream strings and candlelit members.",
    "date": "2026-10-14",
    "dateLabel": "October 14, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "vienna",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "opera"
    ],
    "readingTimeMinutes": 9,
    "cover": "/assets/blog/anatomy-of-the-vienna-theme/cover.webp",
    "icon": "/assets/themes/cities/vienna-theme/icon.webp",
    "coverAccent": "#DCA826",
    "relatedThemes": [
      "vienna"
    ],
    "relatedPlatform": "",
    "relatedColor": "DCA826",
    "relatedPalette": "2C1D1D-6A2F34-DCA826-F4D8B3-D7999F-B6C39C",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-madrid-theme",
      "title": "Anatomy of a Light Theme: Madrid",
      "url": "/blog/anatomy-of-the-madrid-theme",
      "cover": "/assets/blog/anatomy-of-the-madrid-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-spring-theme",
      "title": "Anatomy of a Light Theme: Spring",
      "url": "/blog/anatomy-of-the-spring-theme",
      "cover": "/assets/blog/anatomy-of-the-spring-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Vienna theme?",
        "a": "Vienna is one of Codigrate's premium dark city themes, built around an evening at the opera: velvet seats, candlelit boxes, gilded balconies and the sheet music on the stands. The frame of the editor is the auditorium, crimson and opera velvet reds, and the code is written on a dark mahogany. The syntax is the gold of the house: imperial gold keywords, pastry cream strings and numbers, candlelight fields and methods and marzipan parameters, with a few palace garden greens and one lavender for annotations."
      },
      {
        "q": "Why are the search fields in Vienna darker than the editor?",
        "a": "Because they are the one place you type something new. The editor sits on mahogany #2C1D1D, the panels on opera velvet #4B2226 and the outer frame on crimson #6A2F34, so the backgrounds get redder and lighter the further they are from the code. Search fields and dialog inputs drop below all of them to a black coffee #0B0909, almost black. A field you are about to type into reads as an open slot in the red, and it is impossible to mistake for a panel or a label."
      },
      {
        "q": "How are the syntax colors chosen in Vienna?",
        "a": "Almost all of them sit on one warm stretch of the color wheel, from the rose of local variables at 0 degrees through coral tags at 16, marzipan parameters at 30 and pastry cream strings at 34, to the golds of keywords, fields and attributes between 39 and 43. That is an analogous harmony, the reds of the frame turning slowly into gold. Two palace garden greens near 80 degrees take static members and globals, a lavender at 262 marks annotations, and plain light grey is kept for class, function and constant names."
      },
      {
        "q": "Where can I get the Vienna theme?",
        "a": "Vienna is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Xcode, Zed, Sublime Text, Ghostty, iTerm2, macOS Terminal, Slack and Rhino it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Vienna theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-spring-theme",
    "url": "/blog/anatomy-of-the-spring-theme",
    "title": "Anatomy of a Light Theme: Spring",
    "excerpt": "Anatomy of Spring, a light IDE theme: mint air and new grass for the frame, foxglove keywords, crocus violet values and fern green members, a tulip bed in code.",
    "date": "2026-10-13",
    "dateLabel": "October 13, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "spring",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "tulips"
    ],
    "readingTimeMinutes": 8,
    "cover": "/assets/blog/anatomy-of-the-spring-theme/cover.webp",
    "icon": "/assets/themes/nature/spring-theme/icon.webp",
    "coverAccent": "#BA6173",
    "relatedThemes": [
      "spring"
    ],
    "relatedPlatform": "",
    "relatedColor": "BA6173",
    "relatedPalette": "FAFFF9-BA6173-8C68AC-3C8F63-527FB6-5E9AAE",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-vienna-theme",
      "title": "Anatomy of a Dark Theme: Vienna",
      "url": "/blog/anatomy-of-the-vienna-theme",
      "cover": "/assets/blog/anatomy-of-the-vienna-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-reynisfjara-theme",
      "title": "Anatomy of a Dark Theme: Reynisfjara",
      "url": "/blog/anatomy-of-the-reynisfjara-theme",
      "cover": "/assets/blog/anatomy-of-the-reynisfjara-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Spring theme?",
        "a": "Spring is one of Codigrate's premium light nature themes, built around a garden in April: tulip beds, crocus in the grass and the first new leaves under a clear sky. The frame of the editor is the lawn, a soft new grass green, and the code is written on an almost white page with a breath of green in it. The flowers carry the syntax: foxglove pink keywords, crocus violet strings and numbers, cornflower and robin egg blue variables, with the leaves of the garden in fern and clover greens for everything that belongs to an object."
      },
      {
        "q": "Why is the frame of Spring green?",
        "a": "Because a garden is. Most light themes keep their frame a pale grey or a near white, and Spring keeps its editor that way too. Only the outer frame, the strip the whole window sits in, is a real green: new grass at about 54 percent saturation. It frames the page the way a lawn frames a flower bed, and it means the code area is the lightest and calmest place on the screen, with the color around it rather than under it."
      },
      {
        "q": "How are the syntax colors chosen in Spring?",
        "a": "They split the garden into leaves and flowers. The leaves sit together on the green side of the wheel, between 91 and 148 degrees: fern green fields and methods, a younger leaf green for static members, sprout green annotations, clover tags and a sage for globals. The flowers sit across the wheel from them: foxglove keywords at 348 degrees, a rose for attributes, crocus violet values at 272, and the two blues of the sky, cornflower local variables and robin egg parameters. Keywords are set in bold, so the structure of a file stands out first."
      },
      {
        "q": "Where can I get the Spring theme?",
        "a": "Spring is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Sublime Text, Ghostty, iTerm2, macOS Terminal, Slack and Rhino it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Spring theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-reynisfjara-theme",
    "url": "/blog/anatomy-of-the-reynisfjara-theme",
    "title": "Anatomy of a Dark Theme: Reynisfjara",
    "excerpt": "Anatomy of Reynisfjara, a dark IDE theme: black sand and basalt greys for the frame, washed timber keywords and sea foam values, quiet as a beach at dusk.",
    "date": "2026-10-11",
    "dateLabel": "October 11, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "reynisfjara",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "black sand"
    ],
    "readingTimeMinutes": 8,
    "cover": "/assets/blog/anatomy-of-the-reynisfjara-theme/cover.webp",
    "icon": "/assets/themes/nature/reynisfjara-theme/icon.webp",
    "coverAccent": "#AC8563",
    "relatedThemes": [
      "reynisfjara"
    ],
    "relatedPlatform": "",
    "relatedColor": "AC8563",
    "relatedPalette": "151A20-AC8563-AEB8C5-C3B9AD-99C0D3-91AC8E",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-spring-theme",
      "title": "Anatomy of a Light Theme: Spring",
      "url": "/blog/anatomy-of-the-spring-theme",
      "cover": "/assets/blog/anatomy-of-the-spring-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-sydney-theme",
      "title": "Anatomy of a Light Theme: Sydney",
      "url": "/blog/anatomy-of-the-sydney-theme",
      "cover": "/assets/blog/anatomy-of-the-sydney-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Reynisfjara theme?",
        "a": "Reynisfjara is one of Codigrate's premium dark nature themes, built around the black sand beach on the south coast of Iceland at dusk: basalt columns, sea stacks standing in the surf and driftwood on wet sand. The frame of the editor is the sand and the stone, four dark greys on one cool hue. The code is split between the shore and the sea: the keywords, members and local variables in driftwood and timber browns, the values and parameters in sea foam and a cold horizon blue."
      },
      {
        "q": "Why are the colors in Reynisfjara so muted?",
        "a": "Because the beach is. Reynisfjara is black sand under a grey sky, and almost nothing on it is a strong color. The theme keeps that: no color in the code goes above about 40 percent saturation, and most stay between 12 and 32. The difference between one kind of token and another is carried by the side of the color wheel it sits on, warm sand or cold sea, and by lightness, rather than by brightness. That makes it one of the calmest themes in the series for long sessions."
      },
      {
        "q": "How are the syntax colors chosen in Reynisfjara?",
        "a": "They sit on two sides of the wheel, like Prague's, but with the roles swapped. The warm side, between 28 and 46 degrees, is the driftwood: washed timber keywords, bleached sand fields and methods, pale driftwood local variables, a driftwood grey for tags and an italic pebble for static members. The cool side, near 200 to 214 degrees, is the sea: sea foam strings and numbers, and a cold horizon blue for parameters, the most saturated color in the code. Moss for attributes, lichen for globals and a rosy sand for annotations sit just off that line."
      },
      {
        "q": "Where can I get the Reynisfjara theme?",
        "a": "Reynisfjara is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Sublime Text, Ghostty, iTerm2, macOS Terminal, Slack and Rhino it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Reynisfjara theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-sydney-theme",
    "url": "/blog/anatomy-of-the-sydney-theme",
    "title": "Anatomy of a Light Theme: Sydney",
    "excerpt": "Anatomy of Sydney, a light IDE theme: two whites and a harbour blue frame, reef teal and harbour blue code, warmed by sandstone clay and outback gold.",
    "date": "2026-10-10",
    "dateLabel": "October 10, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "sydney",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "opera house"
    ],
    "readingTimeMinutes": 7,
    "cover": "/assets/blog/anatomy-of-the-sydney-theme/cover.webp",
    "icon": "/assets/themes/cities/sydney-theme/icon.webp",
    "coverAccent": "#2E89A6",
    "relatedThemes": [
      "sydney"
    ],
    "relatedPlatform": "",
    "relatedColor": "2E89A6",
    "relatedPalette": "F6F9FA-2E89A6-2F6781-0290A3-BA7347-AF8427",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-reynisfjara-theme",
      "title": "Anatomy of a Dark Theme: Reynisfjara",
      "url": "/blog/anatomy-of-the-reynisfjara-theme",
      "cover": "/assets/blog/anatomy-of-the-reynisfjara-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-prague-theme",
      "title": "Anatomy of a Dark Theme: Prague",
      "url": "/blog/anatomy-of-the-prague-theme",
      "cover": "/assets/blog/anatomy-of-the-prague-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Sydney theme?",
        "a": "Sydney is one of Codigrate's premium light city themes, built around Sydney Harbour at midday: the white sails of the Opera House, pale blue water full of ferries, and the sandstone of the shore warming in the sun. The editor is a soft opera white, the panels around it a harbour mist and a harbour blue, and the code splits between the water and the land: harbour blues and reef teals for keywords, strings, members and parameters, and desert clay, outback gold and sandstone for local variables, static members, attributes and tags."
      },
      {
        "q": "Why does Sydney use two different whites?",
        "a": "For the same reason the Opera House roof does. Its shells look plain white from the water, but up close they are covered in a chevron of glossy white and matte cream tiles. Sydney does the same on screen: the editor is an opera white #F6F9FA with a breath of harbour blue in it, the soft one you look at for hours, and only the input fields and the gutter go to a pure white, so the place you type is the brightest spot in the window. Selected text turns a sandstone cream #ECE7D1, the one warm white in the theme."
      },
      {
        "q": "How are the syntax colors chosen in Sydney?",
        "a": "They sit on two sides of the wheel. The cool side, between 164 and 199 degrees, is the water: bold harbour blue keywords, deeper harbour blue strings and numbers, reef teal fields and methods, and a deep jade for parameters. The warm side, between 23 and 45 degrees, is the sandstone shore: desert clay for local variables, outback gold for static members and globals, ochre for attributes and a sandstone for tags. Class and function names stay a near black ink, which carries the structure so the colors can stay as soft as the harbour."
      },
      {
        "q": "Where can I get the Sydney theme?",
        "a": "Sydney is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Sublime Text, Ghostty, iTerm2, macOS Terminal, Slack and Rhino it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Sydney theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-prague-theme",
    "url": "/blog/anatomy-of-the-prague-theme",
    "title": "Anatomy of a Dark Theme: Prague",
    "excerpt": "Anatomy of Prague, a dark IDE theme: deep Vltava blues for the frame and the keywords, lit by gas lamp amber, rooftop copper and straw gold.",
    "date": "2026-10-09",
    "dateLabel": "October 9, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "prague",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "gas lamps"
    ],
    "readingTimeMinutes": 8,
    "cover": "/assets/blog/anatomy-of-the-prague-theme/cover.webp",
    "icon": "/assets/themes/cities/prague-theme/icon.webp",
    "coverAccent": "#EFBA5A",
    "relatedThemes": [
      "prague"
    ],
    "relatedPlatform": "",
    "relatedColor": "EFBA5A",
    "relatedPalette": "0D1D2E-74ADF8-89C5F8-EFBA5A-DF865B-E3CA77",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-sydney-theme",
      "title": "Anatomy of a Light Theme: Sydney",
      "url": "/blog/anatomy-of-the-sydney-theme",
      "cover": "/assets/blog/anatomy-of-the-sydney-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-salda-theme",
      "title": "Anatomy of a Light Theme: Salda",
      "url": "/blog/anatomy-of-the-salda-theme",
      "cover": "/assets/blog/anatomy-of-the-salda-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Prague theme?",
        "a": "Prague is one of Codigrate's premium dark city themes, built around Prague after dark: the Vltava running black and blue under the castle, and the gas lamps of Charles Bridge burning along it. The frame of the editor is the river and the night sky, four deep blues on one hue. The code is split between the two: the language itself in river and daylight blues, and the members, parameters and attributes in the warm colors of the old town, amber lantern, rooftop copper, straw gold and parchment."
      },
      {
        "q": "Why does Prague mark selections in gold instead of blue?",
        "a": "Because in a window built entirely from blue, gold is the color that reads as light. Selected text turns a dark brass #544410, the active editor tab sits on a brass shadow #544723 with an old gold underline #C49D3A, the progress bar runs in amber and search matches glow copper. Everything that tells you where you are or what you picked looks like a lamp on the river, and it never gets confused with the blue keywords and strings around it."
      },
      {
        "q": "How are the syntax colors chosen in Prague?",
        "a": "The blues and the golds sit on opposite sides of the color wheel, near 210 and near 30 degrees, and each side gets its own kind of token. The blues carry the language and its values: daylight blue keywords, pale river blue strings and numbers, and an even paler italic blue for static members. The warm side carries what belongs to objects and calls: amber lantern for fields and methods, rooftop copper for parameters and tags, straw gold for attributes and parchment for annotations. A lavender for local variables and a faded brick for globals sit between them."
      },
      {
        "q": "Where can I get the Prague theme?",
        "a": "Prague is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Sublime Text, Ghostty, iTerm2, macOS Terminal, Slack and Rhino it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Prague theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-salda-theme",
    "url": "/blog/anatomy-of-the-salda-theme",
    "title": "Anatomy of a Light Theme: Salda",
    "excerpt": "Anatomy of Salda, a light IDE theme: white sand and warm shore backgrounds, lagoon blue keywords, turquoise strings and a reed green for parameters.",
    "date": "2026-10-08",
    "dateLabel": "October 8, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "salda",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "lake salda"
    ],
    "readingTimeMinutes": 9,
    "cover": "/assets/blog/anatomy-of-the-salda-theme/cover.webp",
    "icon": "/assets/themes/nature/salda-theme/icon.webp",
    "coverAccent": "#1397AE",
    "relatedThemes": [
      "salda"
    ],
    "relatedPlatform": "",
    "relatedColor": "1397AE",
    "relatedPalette": "FDFCFA-44849F-1397AE-277878-0F9363-8F6055",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-prague-theme",
      "title": "Anatomy of a Dark Theme: Prague",
      "url": "/blog/anatomy-of-the-prague-theme",
      "cover": "/assets/blog/anatomy-of-the-prague-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-ocean-theme",
      "title": "Anatomy of a Dark Theme: Ocean",
      "url": "/blog/anatomy-of-the-ocean-theme",
      "cover": "/assets/blog/anatomy-of-the-ocean-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Salda theme?",
        "a": "Salda is one of Codigrate's premium light nature themes, built around Lake Salda in southwestern Turkey, a deep, very clear lake with a shore of bright white sand. The frame of the editor is the shore: white sand, a warm cream and a darker sandbank, with dark cedar text. The code is the water: lakeshore blue keywords in bold, bright lagoon turquoise for strings and numbers, a shaded lagoon teal for local variables and a reed green for parameters, with a clay brown kept for fields and methods."
      },
      {
        "q": "Why does Salda use warm sand backgrounds instead of pure white?",
        "a": "Because a white that leans warm is easier to sit in front of all day than a cold paper white, and because the shore of Lake Salda is not pure white either. The editor is a white sand #FDFCFA, the tool windows a warm shore #FDF6E7 and the outer frame a sandbank #ECE1C9, all near a hue of 41 degrees, so the panels separate by a little more or a little less sand. Only the input fields go to a true white #FFFFFF, which makes the place you type the brightest spot on screen."
      },
      {
        "q": "How are the syntax colors chosen in Salda?",
        "a": "They come from the water side of the lake. The sand of the frame sits near 41 degrees on the color wheel and almost every syntax color sits across from it, between 158 and 222 degrees: reed green parameters, a shaded lagoon for locals, bright lagoon turquoise for strings, lakeshore blue keywords and a deep blue for static members. The few warm colors, a clay brown for fields and methods, a reddish clay for attributes and a driftsand for annotations, stay close to the sand so the frame and the members feel like the same shore."
      },
      {
        "q": "Where can I get the Salda theme?",
        "a": "Salda is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Sublime Text, Ghostty, iTerm2, macOS Terminal, Slack and Rhino it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Salda theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-ocean-theme",
    "url": "/blog/anatomy-of-the-ocean-theme",
    "title": "Anatomy of a Dark Theme: Ocean",
    "excerpt": "Anatomy of Ocean, a dark IDE theme: deep teal water lit by bioluminescent cyan, with the coral, anemone pink and sandbar gold of a reef in a diver's light.",
    "date": "2026-10-07",
    "dateLabel": "October 7, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "ocean",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "bioluminescence"
    ],
    "readingTimeMinutes": 8,
    "cover": "/assets/blog/anatomy-of-the-ocean-theme/cover.webp",
    "icon": "/assets/themes/nature/ocean-theme/icon.webp",
    "coverAccent": "#3FB4D8",
    "relatedThemes": [
      "ocean"
    ],
    "relatedPlatform": "",
    "relatedColor": "3FB4D8",
    "relatedPalette": "102B2E-3FB4D8-69A6F8-DC7783-EE8EBF-EAC089",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-salda-theme",
      "title": "Anatomy of a Light Theme: Salda",
      "url": "/blog/anatomy-of-the-salda-theme",
      "cover": "/assets/blog/anatomy-of-the-salda-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-tallinn-theme",
      "title": "Anatomy of a Light Theme: Tallinn",
      "url": "/blog/anatomy-of-the-tallinn-theme",
      "cover": "/assets/blog/anatomy-of-the-tallinn-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Ocean theme?",
        "a": "Ocean is one of Codigrate's premium dark nature themes, built around the deep sea: dark teal water, the blue and green glow of animals that make their own light, and the corals and sandbars of a reef. The editor is a deep teal instead of black, the frame around it is the same water at a few depths, and the code is lit like a reef in a diver's lamp: tropic cyan for keywords, a bright blue for strings, coral for members, anemone pink for local variables, urchin violet for static members and a pale sandbar gold for parameters."
      },
      {
        "q": "Why is the Ocean background teal instead of black?",
        "a": "Because that is the color water leaves behind. Sea water swallows red light first, so the deeper you go the more everything turns blue green before it turns dark. The input wells #0B2225, the editor #102B2E, the tool windows #18383C and the outer frame #1C4247 all share a hue near 187 degrees and differ only in depth, so the panels separate like layers of water rather than by drawn lines, and the cyan and coral on top read clearer against a colored dark than against a flat black."
      },
      {
        "q": "How are the syntax colors chosen in Ocean?",
        "a": "They follow a reef. The cool half is the water and its glow: tropic cyan keywords, bright blue strings and numbers, sea glass tags and a sea green for global variables. The warm half is the reef itself, set straight across the color wheel from the teal: coral blush for methods and fields, anemone pink for local variables, coral sand for attributes and a pale sandbar gold for parameters. Static members are an italic urchin violet, class and function names stay a light grey, and comments are a sea foam that stays easy to read."
      },
      {
        "q": "Where can I get the Ocean theme?",
        "a": "Ocean is a premium theme. On JetBrains IDEs it is a paid plugin on the JetBrains Marketplace and is also part of the All In One bundle. For Sublime Text, Ghostty, iTerm2, macOS Terminal, Slack and Rhino it is a one time purchase from the Codigrate store, delivered as a download, and the LINE version is sold in the LINE theme shop. All of them are linked from the Ocean theme page."
      }
    ]
  },
  {
    "key": "anatomy-of-the-tallinn-theme",
    "url": "/blog/anatomy-of-the-tallinn-theme",
    "title": "Anatomy of a Light Theme: Tallinn",
    "excerpt": "Anatomy of Tallinn, a light IDE theme: Baltic morning blues, a midnight ink foreground, cobalt keywords, amethyst strings and the red brick of the Old Town.",
    "date": "2026-10-06",
    "dateLabel": "October 6, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "tallinn",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "baltic"
    ],
    "readingTimeMinutes": 7,
    "cover": "/assets/blog/anatomy-of-the-tallinn-theme/cover.webp",
    "icon": "/assets/themes/cities/tallinn-theme/icon.webp",
    "coverAccent": "#425EB8",
    "relatedThemes": [
      "tallinn"
    ],
    "relatedPlatform": "",
    "relatedColor": "425EB8",
    "relatedPalette": "EDF2FA-425EB8-81549C-377CC1-1E7857-B6564B",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-ocean-theme",
      "title": "Anatomy of a Dark Theme: Ocean",
      "url": "/blog/anatomy-of-the-ocean-theme",
      "cover": "/assets/blog/anatomy-of-the-ocean-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-tokyo-theme",
      "title": "Anatomy of a Dark Theme: Tokyo",
      "url": "/blog/anatomy-of-the-tokyo-theme",
      "cover": "/assets/blog/anatomy-of-the-tokyo-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Tallinn theme?",
        "a": "Tallinn is one of Codigrate's light city themes, built around the Estonian capital on a winter morning: pale limestone walls, red tile roofs under snow and a low Baltic sun. The editor is a cool porcelain white instead of a plain white, the text is a midnight blue ink instead of black, and the code is painted in the colors of the Old Town: cobalt for keywords, amethyst for strings, harbor blue for members, spruce and courtyard greens for variables and static members, and the red of old brick for parameters and tags."
      },
      {
        "q": "Why are the Tallinn backgrounds blue instead of white?",
        "a": "Because the whole frame is built from one cold light. The editor #EDF2FA, the tool windows #D0DCEF and the outer frame #A9B9DA share a hue near 217 degrees and differ only in lightness, the color snow takes when the sun stays low and the sky does the lighting. The keywords, the interface text, the caret and the line numbers sit on the same blue, so the code looks like it belongs to the page, and the panels separate by a soft step in depth rather than by drawn lines."
      },
      {
        "q": "How are the syntax colors chosen in Tallinn?",
        "a": "They follow the Old Town from the sky down to the roofs. Keywords are a bold cobalt, the color of the spires against a winter sky, and strings and numbers are a muted amethyst. Methods and fields are a harbor blue, local variables a spruce green and static members a courtyard green. The warm notes are the brick: a red for parameters, a weathered brick for tags, a rust for global variables and an old brass for annotations. Class and function names stay a near black ink, and comments drop to an italic slate grey."
      },
      {
        "q": "Is a pale blue light theme comfortable for long coding sessions?",
        "a": "In a bright room, yes. Code is a midnight blue #0F244F at about 13.5:1 against the editor and names are a near black at about 15:1, so the page reads firmly without the hard edge of pure black on pure white. The blue cast takes the glare off the background, keywords are bold so the structure of a line shows at a glance, and the only strong warm color in the frame is the open tab, so nothing around the code pulls at the eye."
      }
    ]
  },
  {
    "key": "anatomy-of-the-tokyo-theme",
    "url": "/blog/anatomy-of-the-tokyo-theme",
    "title": "Anatomy of a Dark Theme: Tokyo",
    "excerpt": "Anatomy of Tokyo, a dark IDE theme: an indigo night editor lit by neon violet and pink, crisp cyan strings, matcha green and the amber of paper lanterns.",
    "date": "2026-10-05",
    "dateLabel": "October 5, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "tokyo",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "japan blue"
    ],
    "readingTimeMinutes": 7,
    "cover": "/assets/blog/anatomy-of-the-tokyo-theme/cover.webp",
    "icon": "/assets/themes/cities/tokyo-theme/icon.webp",
    "coverAccent": "#7285DC",
    "relatedThemes": [
      "tokyo"
    ],
    "relatedPlatform": "",
    "relatedColor": "7285DC",
    "relatedPalette": "1A1F35-7285DC-ECA1EB-5DC8D6-5CC19D-DD9B7F",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-tallinn-theme",
      "title": "Anatomy of a Light Theme: Tallinn",
      "url": "/blog/anatomy-of-the-tallinn-theme",
      "cover": "/assets/blog/anatomy-of-the-tallinn-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-rio-de-janeiro-theme",
      "title": "Anatomy of a Light Theme: Rio de Janeiro",
      "url": "/blog/anatomy-of-the-rio-de-janeiro-theme",
      "cover": "/assets/blog/anatomy-of-the-rio-de-janeiro-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Tokyo theme?",
        "a": "Tokyo is one of Codigrate's dark city themes, built around Tokyo after midnight: indigo streets, glass towers, neon signs and the paper lanterns of the side alleys. The editor is a deep indigo instead of black, the frame around it is the same blue at lighter depths, and the code is lit by the signs: a pink neon for methods and fields, a cyan for strings, a matcha green for local variables, and an amber and a paper lantern gold for parameters and static members. It reads like a late walk through the city rather than a plain dark mode."
      },
      {
        "q": "Why is the Tokyo background blue instead of black?",
        "a": "Because the whole theme is dyed in one indigo. The input wells #0C0F1C, the editor #1A1F35, the tool windows #2A3051 and the outer frame #323B66 share a hue near 229 degrees, the Japan Blue that dressed the city's work coats and shop curtains in the nineteenth century, and so do the keywords, the caret, the line numbers and the accent. The panels separate by depth rather than by drawn lines, and the neon on top reads brighter against a blue night than against a flat black."
      },
      {
        "q": "How are the syntax colors chosen in Tokyo?",
        "a": "They follow a street at night. Keywords are the indigo of the background lifted toward the light, so the language itself stays quiet. The neon carries the code: pink for methods and fields, cyan for strings and numbers, matcha green for local variables, a pale lime for globals and a skyline blue for tags. Two warm lights are kept for the tokens you search for, an amber for parameters and an italic paper lantern gold for static members. Class and function names stay a light grey, and comments drop to an italic slate."
      },
      {
        "q": "Is Tokyo easy on the eyes for long coding sessions?",
        "a": "In a dim room, yes. Code is a near white #EBEBEC at about 14:1 against the indigo editor and names are a light grey at about 12:1, firm without the glare of pure white on pure black. The frame is one hue at a few depths, so nothing around the code pulls at the eye, and keywords, the most frequent colored words, are the quietest syntax color at under 5:1. The brightest neon is spent on small tokens rather than on large areas."
      }
    ]
  },
  {
    "key": "anatomy-of-the-rio-de-janeiro-theme",
    "url": "/blog/anatomy-of-the-rio-de-janeiro-theme",
    "title": "Anatomy of a Light Theme: Rio de Janeiro",
    "excerpt": "Anatomy of Rio de Janeiro, a light IDE theme: minty morning backgrounds, a forest ink foreground, and syntax in rainforest green, bay blue and samba gold.",
    "date": "2026-10-04",
    "dateLabel": "October 4, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "rio de janeiro",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "burle marx"
    ],
    "readingTimeMinutes": 7,
    "cover": "/assets/blog/anatomy-of-the-rio-de-janeiro-theme/cover.webp",
    "icon": "/assets/themes/cities/rio-de-janeiro-theme/icon.webp",
    "coverAccent": "#13A166",
    "relatedThemes": [
      "rio-de-janeiro"
    ],
    "relatedPlatform": "",
    "relatedColor": "13A166",
    "relatedPalette": "F7FAF6-375B2E-13A166-028134-0A80B3-A3860A",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "premiumThemes": [
      "dublin"
    ],
    "prev": {
      "key": "anatomy-of-the-tokyo-theme",
      "title": "Anatomy of a Dark Theme: Tokyo",
      "url": "/blog/anatomy-of-the-tokyo-theme",
      "cover": "/assets/blog/anatomy-of-the-tokyo-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-paris-theme",
      "title": "Anatomy of a Dark Theme: Paris",
      "url": "/blog/anatomy-of-the-paris-theme",
      "cover": "/assets/blog/anatomy-of-the-paris-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Rio de Janeiro theme?",
        "a": "Rio de Janeiro is one of Codigrate's light city themes, built around the city in the early morning: green hills straight out of the sea, soft light on the bay and the smell of salt in the air. The editor is a pale mint white instead of a plain white, the text is a deep forest green instead of black, and the code is painted in the colors of the place: emerald and jungle greens for the language itself, bay and Atlantic blues for the water, and a samba gold and a sandy caramel for the warm accents. It reads like a walk under the palms by the beach rather than a plain light mode."
      },
      {
        "q": "Why are the Rio de Janeiro backgrounds green instead of white?",
        "a": "Because the whole theme is built around a green city. Rio's light comes from one leafy hue, around 106 degrees: the editor is a morning breeze white #F7FAF6, the tool windows a palm shade #D9EFD2 and the outer frame a jungle canopy #85B778. The greens in the code share that hue, so the syntax looks like it grew out of the page, and the panels separate by a soft step in lightness rather than by drawn lines."
      },
      {
        "q": "How are the syntax colors chosen in Rio de Janeiro?",
        "a": "They follow the city from the hills down to the sea. Keywords are an emerald palm green and strings a deep jungle green, variables a lagoon teal, static members an Atlantic blue and tags a bay blue. The warm notes are the beach and the carnival: a samba gold for methods and fields, and a sandy caramel for parameters. Names such as classes and functions stay a near black ink, and comments drop to an olive grey, so the structure of a line is clear before the color is."
      },
      {
        "q": "Is a green light theme comfortable for long coding sessions?",
        "a": "In a bright room, yes. The editor text is a forest ink #1A510A at about 9:1 against the mint white background, and class and function names are a near black at about 16:1, so the page reads firmly without the hard edge of pure black on pure white. Green sits in the middle of what the eye handles best, and the theme keeps its brightest colors, the gold and the blues, for small accents rather than large areas. In a dim room a dark theme will still feel softer."
      }
    ]
  },
  {
    "key": "anatomy-of-the-paris-theme",
    "url": "/blog/anatomy-of-the-paris-theme",
    "title": "Anatomy of a Dark Theme: Paris",
    "excerpt": "Anatomy of Paris, a dark IDE theme: a plum espresso editor under dusty rose and macaron pinks, warmed by champagne gold and cooled by a twilight blue.",
    "date": "2026-10-03",
    "dateLabel": "October 3, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "paris",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "eiffel tower"
    ],
    "readingTimeMinutes": 7,
    "cover": "/assets/blog/anatomy-of-the-paris-theme/cover.webp",
    "icon": "/assets/themes/cities/paris-theme/icon.webp",
    "coverAccent": "#D584A3",
    "relatedThemes": [
      "paris"
    ],
    "relatedPlatform": "",
    "relatedColor": "D584A3",
    "relatedPalette": "281D22-D18FA8-D584A3-DF7583-F1C970-87A1D3",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "premiumThemes": [
      "vienna"
    ],
    "prev": {
      "key": "anatomy-of-the-rio-de-janeiro-theme",
      "title": "Anatomy of a Light Theme: Rio de Janeiro",
      "url": "/blog/anatomy-of-the-rio-de-janeiro-theme",
      "cover": "/assets/blog/anatomy-of-the-rio-de-janeiro-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-istanbul-theme",
      "title": "Anatomy of a Light Theme: Istanbul",
      "url": "/blog/anatomy-of-the-istanbul-theme",
      "cover": "/assets/blog/anatomy-of-the-istanbul-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Paris theme?",
        "a": "Paris is one of Codigrate's dark city themes, built around Paris in the last light of the evening, when the boulevards go rose and the café windows come on. The editor is a deep plum espresso instead of a neutral charcoal, and the colors on it come from the city at dusk: a Montmartre rose for keywords, a cherry macaron for strings, a peach macaron for methods and fields, champagne gold and café lights for the warm accents, and a twilight blue off the Seine for variables. It reads like an evening walk along the river rather than a plain dark mode."
      },
      {
        "q": "Why is the Paris background plum instead of black or grey?",
        "a": "Because a flat charcoal would make the roses look pasted on. Paris builds every dark from one dusky rose hue, around 335 degrees: the input wells at #100D0E, the editor at #281D22, the tool windows at #4F303C and the outer frame at #6A3C4D. The pinks on top share that undertone, so the syntax sits in the room instead of floating over it, and the panels separate by a clear step in lightness rather than by drawn lines."
      },
      {
        "q": "How are the syntax colors chosen in Paris?",
        "a": "They run in one warm sweep with a single cool answer. The warm side moves from rose to gold: Montmartre rose for keywords, cherry macaron for strings and numbers, peach macaron for methods and fields, café lights for global variables and champagne gold for parameters. The cool side is the Seine at blue hour: a twilight blue for variables and a blue grey for comments. Names such as classes and functions stay a plain light grey, so the structure of a line is clear before the color is."
      },
      {
        "q": "How is Paris different from the Miami theme?",
        "a": "Both are dark city themes built on a rose tinted near black, but they are opposite moods. Miami is loud: a hot neon pink accent, an electric aqua and a bright golden sand, with a teal tab that breaks the room on purpose. Paris is quiet: its pinks are dusty and powdery, its gold is champagne rather than neon, its active tab stays in the same wine family, and only one cool blue is allowed in. Miami is a night out on Ocean Drive; Paris is the walk home along the river."
      }
    ]
  },
  {
    "key": "anatomy-of-the-istanbul-theme",
    "url": "/blog/anatomy-of-the-istanbul-theme",
    "title": "Anatomy of a Light Theme: Istanbul",
    "excerpt": "Anatomy of Istanbul, a light IDE theme: marble white backgrounds, a midnight teal foreground, and syntax in Iznik turquoise, rooftop red and bazaar copper.",
    "date": "2026-10-02",
    "dateLabel": "October 2, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "istanbul",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "iznik tiles"
    ],
    "readingTimeMinutes": 7,
    "cover": "/assets/blog/anatomy-of-the-istanbul-theme/cover.webp",
    "icon": "/assets/themes/cities/istanbul-theme/icon.webp",
    "coverAccent": "#12ACC1",
    "relatedThemes": [
      "istanbul"
    ],
    "relatedPlatform": "",
    "relatedColor": "087E8E",
    "relatedPalette": "FAFDFD-087E8E-1190A1-0887B5-B8514D-B87958",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "premiumThemes": [
      "sydney"
    ],
    "prev": {
      "key": "anatomy-of-the-paris-theme",
      "title": "Anatomy of a Dark Theme: Paris",
      "url": "/blog/anatomy-of-the-paris-theme",
      "cover": "/assets/blog/anatomy-of-the-paris-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-miami-theme",
      "title": "Anatomy of a Dark Theme: Miami",
      "url": "/blog/anatomy-of-the-miami-theme",
      "cover": "/assets/blog/anatomy-of-the-miami-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Istanbul theme?",
        "a": "Istanbul is one of Codigrate's light city themes, built around the city by day: soft daylight on the water, a breeze off the Bosphorus and the tiles of the old mosques. The editor is a marble white with the faintest trace of teal in it, the text is a deep midnight teal instead of black, and the code is painted in the colors of the city: Iznik turquoise and Marmara blue for the language itself, rooftop red, copper and Ottoman rose for the warm accents, and a cypress green for comments. It reads like a bright morning by the water rather than a plain light mode."
      },
      {
        "q": "Why does the Istanbul theme use teal backgrounds instead of plain white?",
        "a": "Because a flat white would leave the turquoise with nothing to belong to. Istanbul builds its light from one teal hue, around 187 degrees: the editor is a marble white #FAFDFD, the tool windows a Bosphorus mist #DBF0F1 and the outer frame a turquoise tile #91D1DA. The keywords, strings and accent on top share that hue, so the syntax looks like it grew out of the page, and the panels separate by a soft step in lightness rather than by drawn lines."
      },
      {
        "q": "How are the syntax colors chosen in Istanbul?",
        "a": "They come in two families. The cool one is the water and the tiles: a Bosphorus teal for keywords, a Marmara blue for strings and numbers, and a deep Iznik cobalt for variables. The warm one is the old city: rooftop red for parameters, copper for methods, fields and attributes, tulip pink for tags and Ottoman rose for annotations. Names such as classes and functions stay a near black ink, and comments drop to a cypress green, so the structure of a line is clear before the color is."
      },
      {
        "q": "Is a light theme like Istanbul good for long coding sessions?",
        "a": "In a bright room, yes. The editor text is a midnight teal #083A41 at about 12:1 against the marble white background, dark enough to read all day without the hard edge of pure black on pure white, and the names in your code are a near black ink at about 17:1. The syntax colors stay in a calm middle range rather than at screen primaries, which keeps a page full of keywords from flickering. In a dim room a dark theme will still feel softer, so many people keep Istanbul for daytime and switch at night."
      }
    ]
  },
  {
    "key": "anatomy-of-the-miami-theme",
    "url": "/blog/anatomy-of-the-miami-theme",
    "title": "Anatomy of a Dark Theme: Miami",
    "excerpt": "Anatomy of Miami, a dark IDE theme: a raspberry black editor lit by neon pink and sunset coral, cooled by electric aqua, palm green and an art deco blue.",
    "date": "2026-09-29",
    "dateLabel": "September 29, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "miami",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme",
      "art deco"
    ],
    "readingTimeMinutes": 7,
    "cover": "/assets/blog/anatomy-of-the-miami-theme/cover.webp",
    "icon": "/assets/themes/cities/miami-theme/icon.webp",
    "coverAccent": "#FF5FA2",
    "relatedThemes": [
      "miami"
    ],
    "relatedPlatform": "",
    "relatedColor": "FF5FA2",
    "relatedPalette": "33121D-FF5FA2-FE8078-F8D273-00D1C1-92B5E8",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "premiumThemes": [
      "vienna"
    ],
    "prev": {
      "key": "anatomy-of-the-istanbul-theme",
      "title": "Anatomy of a Light Theme: Istanbul",
      "url": "/blog/anatomy-of-the-istanbul-theme",
      "cover": "/assets/blog/anatomy-of-the-istanbul-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-sakura-theme",
      "title": "Anatomy of a Light Theme: Sakura",
      "url": "/blog/anatomy-of-the-sakura-theme",
      "cover": "/assets/blog/anatomy-of-the-sakura-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Miami theme?",
        "a": "Miami is one of Codigrate's dark city themes, built around Miami at the hour the sunset hands over to the neon. The editor is a deep raspberry near black instead of a neutral charcoal, and the colors on it come from the city after dark: a hot Miami pink for the accent, sunset coral and flamingo for much of the code, a golden sand for strings, and electric aqua, palm green and a pale art deco blue to cool it all down. It reads like an evening on Ocean Drive rather than a plain dark mode, loud in places but never glaring."
      },
      {
        "q": "Why is the Miami background red instead of black or grey?",
        "a": "Because a flat charcoal would fight the pinks. Miami builds every dark from one hue, around 340 degrees, the raspberry left in the sky once the sun is gone: the input wells at #270D16, the editor at #33121D, the tool windows at #532033 and the outer frame at #5D263A. The pinks and corals on top share that undertone, so the syntax sits in the room instead of floating over it, and the panels separate by a clear step in lightness rather than by drawn lines."
      },
      {
        "q": "How are the syntax colors chosen in Miami?",
        "a": "They come in two families. The warm one is the neon: a soft coral haze for keywords, sunset coral for methods and fields, flamingo for tags, orchid for globals, and a golden sand, the brightest color in the editor, for strings and numbers. The cool one is the tropics: electric aqua for parameters, a pool blue for attributes, palm green for local variables and an italic art deco blue for static members. Comments drop to a lavender grey, the only cool neutral in the theme, so notes step back from the code."
      },
      {
        "q": "Is Miami too bright for long coding sessions?",
        "a": "It is loud on purpose, but the loud colors are placed with care. Keywords, the most frequent colored words in any file, get the softest warm tone in the set, a pastel coral rather than the neon pink, and the hot pink is kept for the interface accent and the caret. Editor text is a pearl white #E4E1E2 at about 13:1 against the background, comfortable rather than stark, and the backgrounds stay deep. In a dim room it feels lively without wearing the eyes out."
      }
    ]
  },
  {
    "key": "anatomy-of-the-sakura-theme",
    "url": "/blog/anatomy-of-the-sakura-theme",
    "title": "Anatomy of a Light Theme: Sakura",
    "excerpt": "Anatomy of Sakura, a light IDE theme: blossom white and petal pink backgrounds, a deep cherry foreground, and syntax in rose, garden green and sky blue.",
    "date": "2026-07-06",
    "dateLabel": "July 6, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "sakura",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme"
    ],
    "readingTimeMinutes": 5,
    "cover": "/assets/blog/anatomy-of-the-sakura-theme/cover.webp",
    "icon": "/assets/themes/nature/sakura-theme/icon.webp",
    "coverAccent": "#CB6B91",
    "relatedThemes": [
      "sakura"
    ],
    "relatedPlatform": "",
    "relatedColor": "B54B66",
    "relatedPalette": "FEFCFC-B54B66-EFA5BF-618C71-397FB7-BC9C5C",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "premiumThemes": [
      "fuji"
    ],
    "prev": {
      "key": "anatomy-of-the-miami-theme",
      "title": "Anatomy of a Dark Theme: Miami",
      "url": "/blog/anatomy-of-the-miami-theme",
      "cover": "/assets/blog/anatomy-of-the-miami-theme/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-roraima-theme",
      "title": "Anatomy of a Dark Theme: Roraima",
      "url": "/blog/anatomy-of-the-roraima-theme",
      "cover": "/assets/blog/anatomy-of-the-roraima-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Sakura theme?",
        "a": "Sakura is one of Codigrate's light nature themes, built around a blooming cherry blossom garden in spring. Soft blossom whites and petal pinks hold the editor like a tree in full bloom, a deep cherry maroon carries the text, and the syntax is painted in the colors of the garden: rose and blush for the blossoms, a calm garden green for the leaves, and a clear sky blue for the day behind them. The whole screen reads like sitting under a flowering tree rather than a plain light mode."
      },
      {
        "q": "Why pink backgrounds instead of a plain white?",
        "a": "A single hard white can glare and feel clinical. Sakura stacks soft blossom tones instead, a near white editor at #FEFCFC over a pale petal window #FCF4F7 and a deeper petal veil frame #F8DBE6, so the light has a blush in it and the panels separate by a soft step rather than a hard line. The faint pink in the whites is what keeps the theme feeling like a tree in bloom and not like a blank page."
      },
      {
        "q": "How are the syntax colors chosen in Sakura?",
        "a": "They come straight from the garden. The blossoms carry the warm code: a blush pink, a rose garden and a deep sakura for the loud and mid tones, with a plum wine and mauve for the quieter ones. The leaves answer in green, a calm tea leaf and a brighter new stem, and the sky sits behind it all in a clear blue for keywords, with a soft pollen gold for the odd warm accent. Nothing reaches for a pure screen primary; every hue is something you would find in a blooming Sakura garden."
      },
      {
        "q": "Is a light theme like Sakura better for your eyes?",
        "a": "Neither light nor dark is automatically easier; what matters is keeping the contrast comfortable and matching the room. A light theme like Sakura helps most in a bright room, where a dark editor can feel like a hole in the page, by keeping the background a soft blush white and the text a deep cherry rather than pure black on pure white. The garden colors also stay off the loudest, most saturated primaries, which keeps the pink from tiring the eyes over a long session."
      }
    ]
  },
  {
    "key": "anatomy-of-the-roraima-theme",
    "url": "/blog/anatomy-of-the-roraima-theme",
    "title": "Anatomy of a Dark Theme: Roraima",
    "excerpt": "Anatomy of Roraima, a dark IDE theme: a near black canyon at nightfall, lit by the oranges and golds of a Roraima sunset against cool twilight blues.",
    "date": "2026-07-05",
    "dateLabel": "July 5, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "roraima",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme"
    ],
    "readingTimeMinutes": 6,
    "cover": "/assets/blog/anatomy-of-the-roraima-theme/cover.webp",
    "icon": "/assets/themes/nature/roraima-theme/icon.webp",
    "coverAccent": "#CC654E",
    "relatedThemes": [
      "roraima"
    ],
    "relatedPlatform": "",
    "relatedColor": "CC654E",
    "relatedPalette": "1E1A1B-CC654E-D1BA46-8F78B7-5292C7-4CC27B",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "premiumThemes": [
      "etna"
    ],
    "prev": {
      "key": "anatomy-of-the-sakura-theme",
      "title": "Anatomy of a Light Theme: Sakura",
      "url": "/blog/anatomy-of-the-sakura-theme",
      "cover": "/assets/blog/anatomy-of-the-sakura-theme/cover.webp"
    },
    "next": {
      "key": "cmyk",
      "title": "CMYK: How Four Inks Print Every Color",
      "url": "/blog/cmyk",
      "cover": "/assets/blog/cmyk/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Roraima theme?",
        "a": "Roraima is one of Codigrate's dark nature themes, built around the sunset over Mount Roraima, the great flat topped tepui in South America. The editor is a near black canyon, warm rather than cold, and the color that lands on it is the sky at that moment: fiery oranges and golds low on the horizon fading up into deep twilight blue and violet. It reads like the last hour of daylight over the mountain rather than a plain dark mode, warm at the bottom, cool at the top, calm all the way through."
      },
      {
        "q": "What backgrounds does Roraima use?",
        "a": "Roraima stacks warm near blacks instead of one flat charcoal. The editor is a deep rock brown at #1E1A1B, the tool windows lift to a canyon shadow #322628, the outer frame to #372C2F, and the input wells drop to the darkest cave floor #171415. Every one carries a trace of red and brown, the color of the tepui stone rather than of neutral grey, so the dark has warmth in it and the panels separate by a soft step of lightness rather than a hard line."
      },
      {
        "q": "How are the syntax colors chosen in Roraima?",
        "a": "They are split across the sunset sky. The warm half carries most of the code: a coral orange for the loud tokens, amber and sand for the mid tones, and gold for the quieter ones, the fire low on the horizon. The cool half answers it: a river blue and a soft violet for keywords and structure, the twilight climbing above the glow, with a valley green held back for strings so they read clearly against the warm. Nothing reaches for a pure screen primary; every hue is somewhere in that one sunset."
      },
      {
        "q": "Is Roraima good for long coding sessions?",
        "a": "That is what the warm near black is for. A dark theme is easiest on the eyes in a dim room, and Roraima keeps its background low and warm so the screen is not a cold hole in a dark space, with the text a soft cloud grey rather than harsh pure white. The syntax stays mostly in warm earth and sunset tones and rations its brightest colors, so the code has clear structure without a scatter of loud, saturated signals to tire you out over a long stretch."
      }
    ]
  },
  {
    "key": "cmyk",
    "url": "/blog/cmyk",
    "title": "CMYK: How Four Inks Print Every Color",
    "excerpt": "CMYK reads backwards from every screen model: you start on white paper and subtract light with ink. Why the black K exists, and why neon never quite prints.",
    "date": "2026-07-04",
    "dateLabel": "July 4, 2026",
    "category": "color-theory",
    "categoryLabel": "Color Theory",
    "tags": [
      "cmyk",
      "subtractive color",
      "print color",
      "cyan magenta yellow key",
      "process color",
      "color model",
      "color theory",
      "gamut"
    ],
    "readingTimeMinutes": 5,
    "cover": "/assets/blog/cmyk/cover.webp",
    "icon": "/assets/blog/cmyk/icon.svg",
    "coverAccent": "#E14C86",
    "relatedThemes": [
      "miami"
    ],
    "relatedPlatform": "",
    "relatedColor": "FF5FA2",
    "relatedPalette": "",
    "relatedGradient": "",
    "relatedConverters": [
      "hex-to-cmyk",
      "cmyk-to-hex"
    ],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-roraima-theme",
      "title": "Anatomy of a Dark Theme: Roraima",
      "url": "/blog/anatomy-of-the-roraima-theme",
      "cover": "/assets/blog/anatomy-of-the-roraima-theme/cover.webp"
    },
    "next": {
      "key": "hwb",
      "title": "HWB: Pick a Hue, Add White, Add Black",
      "url": "/blog/hwb",
      "cover": "/assets/blog/hwb/cover.webp"
    },
    "faq": [
      {
        "q": "What is CMYK color?",
        "a": "CMYK is the color model of print. It describes a color as four ink amounts laid on white paper: cyan, magenta, yellow, and key, which is black. Each value is a coverage percentage, how much of that ink the press puts down. With all four at zero nothing prints and you see bare paper; as the numbers rise the inks absorb more of the light bouncing off the page and the color darkens. It is subtractive, the opposite of the additive red, green and blue a screen glows, which is why the same color needs different numbers for print than for a monitor."
      },
      {
        "q": "Why does CMYK have a K (black) channel if it already has cyan, magenta and yellow?",
        "a": "In theory the three colored inks at full strength should absorb all the light and leave black. In practice they leave a muddy brown, because real inks are not perfectly pure and three wet layers never register exactly. So presses add a dedicated black ink. It prints a true black the colors cannot reach, it deepens shadows without flooding them with costly colored ink, and it keeps small black text sharp instead of fringed by three slightly misaligned layers. It is called key because the other three inks are lined up, registered, against it."
      },
      {
        "q": "What is the difference between CMYK and RGB?",
        "a": "They run in opposite directions. RGB is additive: a screen starts black and adds red, green and blue light until it reaches white, so more light means a brighter color. CMYK is subtractive: paper starts white and adds ink that removes light until it reaches black, so more ink means a darker color. RGB also covers a wider range, because glowing light can be more vivid than reflected ink. The neon colors a monitor shows often have no CMYK recipe that matches them, which is why bright screen designs look calmer once they are printed."
      },
      {
        "q": "Can I use CMYK in CSS or on the web?",
        "a": "No. There is no cmyk() function in CSS, because the web paints with light and CMYK paints with ink, and a browser has no press to send the numbers to. CMYK lives in the files that do reach a press: design tool swatches, PDF color fields, printer setups. On the web you keep the color as hex or rgb and treat its CMYK build as the print-ready twin. To move between them, convert: read a hex code as ink percentages when a color has to be printed, and read ink percentages back to hex when a printed color has to go on screen."
      }
    ]
  },
  {
    "key": "hwb",
    "url": "/blog/hwb",
    "title": "HWB: Pick a Hue, Add White, Add Black",
    "excerpt": "HWB reads like a mixing recipe: a hue, some white, some black. How sakura pink falls out of a rose hue drowned in white, and where hwb() works in CSS.",
    "date": "2026-07-03",
    "dateLabel": "July 3, 2026",
    "category": "color-theory",
    "categoryLabel": "Color Theory",
    "tags": [
      "hwb",
      "css color",
      "color model",
      "hue",
      "tint",
      "shade",
      "tone",
      "whiteness",
      "blackness",
      "color theory"
    ],
    "readingTimeMinutes": 6,
    "cover": "/assets/blog/hwb/cover.webp",
    "icon": "/assets/blog/hwb/icon.svg",
    "coverAccent": "#CC5993",
    "relatedThemes": [
      "sakura"
    ],
    "relatedPlatform": "",
    "relatedColor": "DE8CB5",
    "relatedPalette": "",
    "relatedGradient": "",
    "relatedConverters": [
      "hex-to-hwb",
      "hwb-to-hex"
    ],
    "relatedRepo": "",
    "prev": {
      "key": "cmyk",
      "title": "CMYK: How Four Inks Print Every Color",
      "url": "/blog/cmyk",
      "cover": "/assets/blog/cmyk/cover.webp"
    },
    "next": {
      "key": "dark-mode-vs-light-mode",
      "title": "Dark Mode and Light Mode: What Your Eyes Actually Want",
      "url": "/blog/dark-mode-vs-light-mode",
      "cover": "/assets/blog/dark-mode-vs-light-mode/cover.webp"
    },
    "faq": [
      {
        "q": "What is HWB color?",
        "a": "HWB describes a color as a mixing recipe: a hue angle on the color wheel, a whiteness percentage saying how much white is folded in, and a blackness percentage saying how much black. With both at zero you get the pure hue at full strength, and every other value of the hue comes from stirring white or black into it. It is part of CSS Color 4, written hwb(330 55% 13%), and it is the notation closest to how painters actually mix color."
      },
      {
        "q": "How is HWB different from HSL?",
        "a": "They share the same hue wheel, so the first number means the same thing in both. The other two dials differ. HSL steers a color with saturation and lightness, two abstract axes you adjust until it looks right. HWB steers it with the amount of white and the amount of black mixed into the pure hue, which maps straight onto the old painter vocabulary: white only makes a tint, black only makes a shade, both together make a tone. The same color can always be written both ways; they are two recipes for one result."
      },
      {
        "q": "What happens when whiteness and blackness add up to 100 or more?",
        "a": "The hue runs out of room. Whiteness and blackness each claim a share of the mix, and once the two shares fill it completely there is nothing left for the hue to color. CSS resolves the overflow by scaling the two values down to fit, and the result is the neutral grey given by whiteness divided by the sum of the two. So hwb(330 80% 60%) is the same mid grey you would get at any other hue angle, because the 330 never gets a say."
      },
      {
        "q": "Do browsers support hwb() in CSS?",
        "a": "Yes. The hwb() function is part of CSS Color 4 and has shipped in every major engine since early 2022, so any current browser reads it. The syntax separates the three values with spaces rather than commas, hwb(330 55% 13%), and an alpha channel goes after a slash, hwb(330 55% 13% / 0.5). If you need to reach further back than 2022 era browsers, serve the same color as hex or rgb() and keep hwb() as the readable source of truth."
      }
    ]
  },
  {
    "key": "dark-mode-vs-light-mode",
    "url": "/blog/dark-mode-vs-light-mode",
    "title": "Dark Mode and Light Mode: What Your Eyes Actually Want",
    "excerpt": "Neither mode is easier on your eyes by default. What dark and light mode do to your pupils, why good dark themes skip pure black, and how to pick by room light.",
    "date": "2026-07-02",
    "dateLabel": "July 2, 2026",
    "category": "accessibility",
    "categoryLabel": "Accessibility",
    "tags": [
      "dark mode",
      "light mode",
      "dark mode vs light mode",
      "eye strain",
      "contrast polarity",
      "readability",
      "accessibility",
      "ide theme",
      "ui design",
      "interactive demo"
    ],
    "readingTimeMinutes": 6,
    "cover": "/assets/blog/dark-mode-vs-light-mode/cover.webp",
    "icon": "/assets/blog/dark-mode-vs-light-mode/icon.svg",
    "coverAccent": "#ED8620",
    "relatedThemes": [
      "aurora-borealis",
      "everest"
    ],
    "relatedPlatform": "",
    "relatedColor": "ED8620",
    "relatedPalette": "",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "hwb",
      "title": "HWB: Pick a Hue, Add White, Add Black",
      "url": "/blog/hwb",
      "cover": "/assets/blog/hwb/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-autumn-theme",
      "title": "Anatomy of a Light Theme: Autumn",
      "url": "/blog/anatomy-of-the-autumn-theme",
      "cover": "/assets/blog/anatomy-of-the-autumn-theme/cover.webp"
    },
    "faq": [
      {
        "q": "Is dark mode better for your eyes?",
        "a": "Not by itself. Reading studies mostly find a small edge for dark text on a light background, because a bright page makes your pupils contract and a smaller pupil focuses more sharply. Dark mode wins on comfort in a dim room, where a bright page would be the harshest light source in sight. So the honest answer is that the room decides: light mode in bright surroundings, dark mode in dim ones, and comfortable contrast in both."
      },
      {
        "q": "Why does white text on black look blurry to some people?",
        "a": "The effect is called halation: bright strokes on a dark field seem to glow and bleed into the background. On a dark screen your pupils open wider, and a wider pupil magnifies any small focusing error in the eye. Roughly one person in three has some degree of astigmatism, so for a large share of readers thin light text on a dark page smears slightly no matter how sharp the screen is. Softer text colors and slightly lighter backgrounds reduce it."
      },
      {
        "q": "Does dark mode save battery?",
        "a": "On OLED screens, yes. An OLED pixel showing true black is simply off and draws almost nothing, and dark grey pixels still draw far less than white ones, so a dark theme can cut display power noticeably. On LCD screens the backlight stays on behind every pixel regardless of color, so a dark theme saves little to nothing there. The display technology, not the theme, decides whether the saving is real."
      },
      {
        "q": "Should a dark theme use pure black?",
        "a": "Almost never. Pure white text on pure black is the highest contrast a screen can produce, 21 to 1, and at paragraph length that extreme reads as harsh and makes halation worse. Well built dark themes start from a deep tinted surface instead of black and soften the text to a light grey, landing the contrast well past the accessibility minimum but far below the maximum. The result reads as calm instead of glaring."
      }
    ]
  },
  {
    "key": "anatomy-of-the-autumn-theme",
    "url": "/blog/anatomy-of-the-autumn-theme",
    "title": "Anatomy of a Light Theme: Autumn",
    "excerpt": "Anatomy of Autumn, a light IDE theme: warm cream backgrounds, a deep espresso foreground, and syntax in the rust, gold and green of fall leaves.",
    "date": "2026-07-01",
    "dateLabel": "July 1, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "autumn",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme"
    ],
    "readingTimeMinutes": 6,
    "cover": "/assets/blog/anatomy-of-the-autumn-theme/cover.webp",
    "icon": "/assets/themes/nature/autumn-theme/icon.webp",
    "coverAccent": "#C85808",
    "relatedThemes": [
      "autumn"
    ],
    "relatedPlatform": "",
    "relatedColor": "DEA51D",
    "relatedPalette": "F8F4F1-DEA51D-BE553E-A87F25-1B591E-006E83",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "dark-mode-vs-light-mode",
      "title": "Dark Mode and Light Mode: What Your Eyes Actually Want",
      "url": "/blog/dark-mode-vs-light-mode",
      "cover": "/assets/blog/dark-mode-vs-light-mode/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-sequoia-theme",
      "title": "Anatomy of a Dark Theme: Sequoia",
      "url": "/blog/anatomy-of-the-sequoia-theme",
      "cover": "/assets/blog/anatomy-of-the-sequoia-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Autumn theme?",
        "a": "Autumn is one of Codigrate's light nature themes, built around a bright afternoon late in the year. Warm cream and near white backgrounds hold the editor like sunlight on a clear day, a deep espresso brown carries the text, and the syntax is painted in the colors of fall leaves, rust and burnt sienna, ochre and gold, deep forest green and a cool teal for the crisp air. The whole screen reads like a walk through turning trees rather than a plain light mode."
      },
      {
        "q": "Why cream and white backgrounds instead of one flat white?",
        "a": "A single hard white can glare and flatten everything on top of it. Autumn stacks warm off whites instead, a near white editor around #FCFBFA over a cream window #F8F4F1 and a deeper linen frame, so the light has warmth in it and the panels separate by a soft step rather than a hard line. The faint warmth in the whites is what keeps the theme feeling like afternoon sun and not like a blank page."
      },
      {
        "q": "How are the syntax colors chosen in Autumn?",
        "a": "They are the colors of fall itself. Globals take a rust red, parameters a burnt sienna, locals and metadata a deep bark brown, and fields an ochre gold, the browns and reds of turning leaves. Strings and numbers sit in a deep forest green, locals of the living kind in a brighter green, and keywords in a cool teal like the air between the trees. Nothing reaches for a primary screen color, every hue is something you would find on an autumn walk, which is what gives the theme its warm, settled feel."
      },
      {
        "q": "Is a light theme better for your eyes?",
        "a": "Neither light nor dark is automatically easier; what matters is keeping the contrast in a comfortable range and matching the room. A light theme like Autumn helps most in a bright room, where a dark editor can feel like a hole in the page, by keeping the background warm and high and the text a deep brown rather than pure black on pure white. The earth toned syntax also stays off the loudest, most saturated colors, which keeps long sessions calm."
      }
    ]
  },
  {
    "key": "anatomy-of-the-sequoia-theme",
    "url": "/blog/anatomy-of-the-sequoia-theme",
    "title": "Anatomy of a Dark Theme: Sequoia",
    "excerpt": "Anatomy of Sequoia, a dark IDE theme: a near black forest floor in olive charcoal, a soft grey foreground, and syntax in the earth tones of a redwood forest.",
    "date": "2026-06-30",
    "dateLabel": "June 30, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "sequoia",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme"
    ],
    "readingTimeMinutes": 5,
    "cover": "/assets/blog/anatomy-of-the-sequoia-theme/cover.webp",
    "icon": "/assets/themes/nature/sequoia-theme/icon.webp",
    "coverAccent": "#73A621",
    "relatedThemes": [
      "sequoia"
    ],
    "relatedPlatform": "",
    "relatedColor": "73A621",
    "relatedPalette": "20231C-73A621-369772-A68F59-A86255-A67B5B",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-autumn-theme",
      "title": "Anatomy of a Light Theme: Autumn",
      "url": "/blog/anatomy-of-the-autumn-theme",
      "cover": "/assets/blog/anatomy-of-the-autumn-theme/cover.webp"
    },
    "next": {
      "key": "what-is-a-gradient",
      "title": "Gradients: Color That Depends on Position",
      "url": "/blog/what-is-a-gradient",
      "cover": "/assets/blog/what-is-a-gradient/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Sequoia theme?",
        "a": "Sequoia is one of Codigrate's dark nature themes, built around the deep, shaded floor of a redwood forest. A near black olive charcoal editor sits under a soft grey foreground, the syntax is painted in earth tones, bark browns, redwood reds and golden light, and a single vibrant green accent runs through the interface like new growth, so the whole screen feels like working under the canopy."
      },
      {
        "q": "Why is the background a deep olive charcoal instead of pure black?",
        "a": "Pure black against bright text makes the harshest possible contrast, which can buzz and tire the eyes, and it shows every smudge and halo on a screen. Sequoia uses a near black olive charcoal instead, around #20231C for the editor, so the contrast with the soft grey text lands in a comfortable band and the background reads like shaded ground rather than a flat void. The faint green in it is what keeps the theme feeling like a forest and not just a dark mode."
      },
      {
        "q": "How are the syntax colors chosen in Sequoia?",
        "a": "They are the colors of the forest itself. Keywords take a bark tan, strings and numbers a golden light, local variables a redwood terracotta and globals a deeper bark brown, while methods and fields glow in leaf and pine greens and annotations sit in a lichen teal. Nothing is a primary screen color, every hue is something you would actually find among trees, which is what gives the theme its earthy, settled feel."
      },
      {
        "q": "Is a dark theme better for your eyes?",
        "a": "Neither dark nor light is automatically easier; what matters is keeping the contrast in a comfortable range and avoiding glare. A dark theme like Sequoia helps most in a dim room, where a bright white page can feel harsh, by keeping the background low and the foreground a soft grey rather than pure white on pure black. The earth toned syntax also stays off the loudest, most saturated colors, which keeps long sessions calm."
      }
    ]
  },
  {
    "key": "what-is-a-gradient",
    "url": "/blog/what-is-a-gradient",
    "title": "Gradients: Color That Depends on Position",
    "excerpt": "A gradient makes the color depend on where you are on a surface. How color stops, linear, radial and conic shapes, and repeating gradients actually work.",
    "date": "2026-06-29",
    "dateLabel": "June 29, 2026",
    "category": "palette-harmony",
    "categoryLabel": "Palette & Harmony",
    "tags": [
      "gradient",
      "gradients",
      "css gradient",
      "linear gradient",
      "radial gradient",
      "conic gradient",
      "color stops",
      "repeating gradient",
      "background gradient",
      "css background",
      "color blend",
      "gradient generator",
      "color theory",
      "ui design"
    ],
    "readingTimeMinutes": 4,
    "cover": "/assets/blog/what-is-a-gradient/cover.webp",
    "icon": "/assets/blog/what-is-a-gradient/icon.svg",
    "coverAccent": "#1FC274",
    "relatedThemes": [
      "spring"
    ],
    "relatedPlatform": "",
    "relatedColor": "1FC274",
    "relatedPalette": "",
    "relatedGradient": "1FC274-A65AD6",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-sequoia-theme",
      "title": "Anatomy of a Dark Theme: Sequoia",
      "url": "/blog/anatomy-of-the-sequoia-theme",
      "cover": "/assets/blog/anatomy-of-the-sequoia-theme/cover.webp"
    },
    "next": {
      "key": "value",
      "title": "Value: How Colors Get Vivid",
      "url": "/blog/value",
      "cover": "/assets/blog/value/cover.webp"
    },
    "faq": [
      {
        "q": "What is a color gradient?",
        "a": "A color gradient is a fill where the color changes across a surface instead of staying the same. You set a few key colors, called color stops, and the browser blends smoothly between them so every point on the shape gets its own color based on where it sits. The same idea covers a soft two color fade, a sunset that runs through many colors, and a glow that radiates out from a single point."
      },
      {
        "q": "What are color stops in a gradient?",
        "a": "A color stop is one color pinned to a position along the gradient. Between any two stops the color slides smoothly from one to the next, so two stops make a simple fade and adding more stops lets the gradient pass through several colors on the way across. Positions are usually written as percentages, and moving them changes where each color sits and how much room the blend gets. Placing two stops at the very same position leaves no room to blend, which gives you a hard edge instead of a fade."
      },
      {
        "q": "What is the difference between linear, radial and conic gradients?",
        "a": "They differ in how the gradient measures position. A linear gradient runs the colors along a straight line set by an angle, so the color changes in one direction across the shape. A radial gradient spreads the colors out in rings from a center point, so the color changes with distance from that point. A conic gradient sweeps the colors around a center by angle, like the hand of a clock, which is why it suits pie charts and color wheels."
      },
      {
        "q": "What is a repeating gradient?",
        "a": "A repeating gradient defines one short run of color stops and tiles it across the shape instead of stretching it to fit once. Each gradient type has a repeating version: repeating linear makes stripes, repeating radial makes concentric rings like a target, and repeating conic makes evenly spaced wedges. You describe a single band of stops and the pattern copies itself as many times as the surface allows."
      }
    ]
  },
  {
    "key": "value",
    "url": "/blog/value",
    "title": "Value: How Colors Get Vivid",
    "excerpt": "Value is the V in HSV, the brightness dial that tops out at the pure color, not white. How it differs from lightness, and why designers reach for it.",
    "date": "2026-06-28",
    "dateLabel": "June 28, 2026",
    "category": "color-theory",
    "categoryLabel": "Color Theory",
    "tags": [
      "value",
      "hsv",
      "hsb",
      "brightness",
      "lightness",
      "hue",
      "saturation",
      "color theory",
      "ui design"
    ],
    "readingTimeMinutes": 5,
    "cover": "/assets/blog/value/cover.webp",
    "icon": "/assets/blog/value/icon.svg",
    "coverAccent": "#E5383B",
    "relatedThemes": [
      "etna"
    ],
    "relatedPlatform": "",
    "relatedColor": "F94144",
    "relatedPalette": "true",
    "relatedGradient": "",
    "relatedConverters": [
      "hex-to-hsv",
      "hsv-to-hex"
    ],
    "relatedRepo": "",
    "prev": {
      "key": "what-is-a-gradient",
      "title": "Gradients: Color That Depends on Position",
      "url": "/blog/what-is-a-gradient",
      "cover": "/assets/blog/what-is-a-gradient/cover.webp"
    },
    "next": {
      "key": "lightness",
      "title": "Lightness: Deciding What You Can Read",
      "url": "/blog/lightness",
      "cover": "/assets/blog/lightness/cover.webp"
    },
    "faq": [
      {
        "q": "What is value in the HSV color model?",
        "a": "Value is the V in HSV, the dial that says how bright a color is. Turn it all the way down and you get black, turn it all the way up and you get the brightest version of that hue. The catch is what brightest means here. In HSV the top of the value dial is the pure, fully saturated color, not white, so a value of one hundred percent on a saturated red gives you a vivid red rather than the pale pink or the plain white you might expect."
      },
      {
        "q": "What is the difference between value and lightness?",
        "a": "They both measure brightness but they put the ceiling in different places. Lightness, the L in HSL, runs from black at the bottom through the pure color in the middle and on to white at the top, so its brightest point is white. Value, the V in HSV, runs from black at the bottom straight up to the pure color at the top, and it never reaches white at all. A fully saturated red sits at fifty percent lightness in HSL but at one hundred percent value in HSV, the same color landing in two different spots depending on which model you ask."
      },
      {
        "q": "What does HSV stand for and is it the same as HSB?",
        "a": "HSV stands for hue, saturation and value. HSB stands for hue, saturation and brightness, and it is the exact same model under a different name, so value and brightness mean the same thing here. Photoshop and many design tools label the dial brightness while code and color pickers tend to label it value, but the math is identical. Both describe a cylinder where the pure colors live around the top edge and black sits at the bottom point."
      },
      {
        "q": "When should you use HSV instead of HSL?",
        "a": "Reach for HSV when you are tuning a single color by eye, especially picking shades that stay vivid. Because the value dial climbs straight to the pure color, pulling it down gives you a clean run of darker shades without the color washing toward white, which is how most color pickers let you drag a square and grab a swatch. Reach for HSL when you are reasoning about contrast and readability, since its symmetric black to white axis lines up with how the eye reads light and dark."
      }
    ]
  },
  {
    "key": "lightness",
    "url": "/blog/lightness",
    "title": "Lightness: Deciding What You Can Read",
    "excerpt": "Lightness is how light or dark a color is, the L in HSL: why opposite colors can share one, why contrast lives there, and how to design in grey first.",
    "date": "2026-06-27",
    "dateLabel": "June 27, 2026",
    "category": "color-theory",
    "categoryLabel": "Color Theory",
    "tags": [
      "lightness",
      "hsl",
      "brightness",
      "contrast",
      "readability",
      "value",
      "color theory",
      "ui design"
    ],
    "readingTimeMinutes": 5,
    "cover": "/assets/blog/lightness/cover.webp",
    "icon": "/assets/blog/lightness/icon.svg",
    "coverAccent": "#40E0D0",
    "relatedThemes": [],
    "relatedPlatform": "",
    "relatedColor": "40E0D0",
    "relatedPalette": "true",
    "relatedGradient": "",
    "relatedConverters": [
      "hex-to-hsl",
      "hsl-to-hex"
    ],
    "relatedRepo": "",
    "prev": {
      "key": "value",
      "title": "Value: How Colors Get Vivid",
      "url": "/blog/value",
      "cover": "/assets/blog/value/cover.webp"
    },
    "next": {
      "key": "saturation",
      "title": "Saturation: Deciding What Stands Out",
      "url": "/blog/saturation",
      "cover": "/assets/blog/saturation/cover.webp"
    },
    "faq": [
      {
        "q": "What is lightness in color?",
        "a": "Lightness is how light or dark a color is, the plain distance from black to white. It is the L in HSL, the third dial alongside hue and saturation, and every color carries one. Drain a color of its hue and its saturation and the grey you are left holding is its lightness, the color reduced to nothing but brightness. A lemon yellow has a high lightness because it sits near white, a navy has a low one because it sits near black, and the hue itself has no say in either."
      },
      {
        "q": "What is the difference between lightness and saturation?",
        "a": "They are separate axes. Lightness is light or dark, how close a color is to white or black. Saturation is how far the color sits from grey, how pure or muted it is. You can take one color and lighten it without muting it, or mute it without darkening it, because the two dials move independently. Most palettes that feel off are a lightness problem being mistaken for a saturation one, or the reverse."
      },
      {
        "q": "Why does lightness matter for contrast and readability?",
        "a": "Because the contrast your eye actually reads is lightness contrast. Two colors with opposite hues but the same lightness have almost no contrast and blur together when you squint, which is why text needs a clear lightness gap from its background, not just a different color. A contrast ratio is, underneath the math, a measure of how far two colors sit apart in lightness, so a heading stays readable through any hue as long as its lightness holds."
      },
      {
        "q": "Is lightness the same as the value in HSV?",
        "a": "They are close cousins but not the same. Lightness is the L in HSL, a symmetric axis with black at the bottom, white at the top, and the pure hue sitting halfway. Value is the V in HSV, and it tops out at the pure, fully bright color rather than white, so the two models place a colour's brightness differently. A pure red is the clearest example: it sits at fifty percent lightness in HSL but at full value in HSV, the same color landing in two different spots depending on which model you ask."
      }
    ]
  },
  {
    "key": "saturation",
    "url": "/blog/saturation",
    "title": "Saturation: Deciding What Stands Out",
    "excerpt": "Saturation decides what stands out: what it is, why color fades to grey not white, why full blast looks cheap, and how one vivid accent carries a muted palette.",
    "date": "2026-06-26",
    "dateLabel": "June 26, 2026",
    "category": "color-theory",
    "categoryLabel": "Color Theory",
    "tags": [
      "saturation",
      "chroma",
      "muted colors",
      "tint tone shade",
      "visual hierarchy",
      "hsl",
      "color theory",
      "ui design"
    ],
    "readingTimeMinutes": 6,
    "cover": "/assets/blog/saturation/cover.webp",
    "icon": "/assets/blog/saturation/icon.svg",
    "coverAccent": "#07A1AB",
    "relatedThemes": [],
    "relatedPlatform": "",
    "relatedColor": "3BE3D2",
    "relatedPalette": "true",
    "relatedGradient": "",
    "relatedConverters": [
      "hex-to-hsl",
      "hsl-to-hex"
    ],
    "relatedRepo": "",
    "prev": {
      "key": "lightness",
      "title": "Lightness: Deciding What You Can Read",
      "url": "/blog/lightness",
      "cover": "/assets/blog/lightness/cover.webp"
    },
    "next": {
      "key": "warm-and-cool-colors",
      "title": "Warm and Cool Colors",
      "url": "/blog/warm-and-cool-colors",
      "cover": "/assets/blog/warm-and-cool-colors/cover.webp"
    },
    "faq": [
      {
        "q": "What is color saturation?",
        "a": "Saturation is how far a color sits from grey. A fully saturated color is pure pigment with no grey mixed in, the loudest version of that hue. Drain the saturation and the color fades toward a grey of the same brightness, until at zero it is grey with no hue left at all. Crucially the hue never changes as you do this, only its intensity, which is why a fire engine and a faded brick can be the very same red turned up and turned down."
      },
      {
        "q": "Why do highly saturated colors look cheap or tiring?",
        "a": "Because nothing on screen gets to rest. When every element runs at full saturation they all shout at once, the eye finds no quiet place to land, and the design reads as loud rather than confident. It is the look of a child's toy and a bad slide deck. Even nature rarely goes full blast, since the most vivid sunset is still softened by grey, so a screen that does feels artificial."
      },
      {
        "q": "What is the difference between saturation and brightness?",
        "a": "Saturation is how pure a color is, how far from grey. Brightness, or lightness, is how light or dark it is, how close to white or black. They move on separate axes, so you can take one red and make it paler without muting it, or muddier without darkening it. Mixing the two up is the usual reason a palette feels off, because the fix was a saturation problem being solved with a brightness change."
      },
      {
        "q": "How do you use saturation in a color palette?",
        "a": "Pick one saturation level for most of the surface and keep it there, usually a calmer, muted base, then spend full saturation on the one or two things that have to be seen. A muted field gives a single vivid accent somewhere to stand out, so the eye lands on the button or the price without any help from size or contrast. Lead with restraint and let saturation mark what matters."
      }
    ]
  },
  {
    "key": "warm-and-cool-colors",
    "url": "/blog/warm-and-cool-colors",
    "title": "Warm and Cool Colors",
    "excerpt": "Color temperature explained: which half of the wheel runs warm, which runs cool, what each side signals, and how to lead a design with the split.",
    "date": "2026-06-25",
    "dateLabel": "June 25, 2026",
    "category": "color-theory",
    "categoryLabel": "Color Theory",
    "tags": [
      "warm colors",
      "cool colors",
      "color temperature",
      "hue",
      "color theory",
      "ui design"
    ],
    "readingTimeMinutes": 6,
    "cover": "/assets/blog/warm-and-cool-colors/cover.webp",
    "icon": "/assets/blog/warm-and-cool-colors/icon.svg",
    "coverAccent": "#E0683C",
    "relatedThemes": [],
    "relatedPlatform": "",
    "relatedColor": "E0683C",
    "relatedPalette": "true",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "saturation",
      "title": "Saturation: Deciding What Stands Out",
      "url": "/blog/saturation",
      "cover": "/assets/blog/saturation/cover.webp"
    },
    "next": {
      "key": "designing-for-color-blindness",
      "title": "Designing for Color Vision Deficiency",
      "url": "/blog/designing-for-color-blindness",
      "cover": "/assets/blog/designing-for-color-blindness/cover.webp"
    },
    "faq": [
      {
        "q": "What are warm and cool colors?",
        "a": "Warm colors are the reds, oranges and yellows, the half of the wheel that reads as fire, sun and skin. Cool colors are the greens, blues and violets, the half that reads as water, ice and shade. The split is one of the oldest tools in color theory because it files every hue into one of two moods before you decide anything else about a palette."
      },
      {
        "q": "What do warm and cool colors signal?",
        "a": "Warm colors read as energy, appetite, urgency and closeness, which is why sale tags, stop signs and calls to action lean red and orange. Cool colors read as calm, trust, focus and distance, which is why banks, tech and medical brands lean blue, and growth and money lean green. The temperature you lead with carries half the message before a word is read."
      },
      {
        "q": "Where is the line between warm and cool on the color wheel?",
        "a": "Roughly across the middle. Reds, oranges and yellows sit on the warm side, greens, blues and violets on the cool side, with the handover landing somewhere around yellow green on one edge and near magenta on the other. The exact crossing is a matter of taste, and a color parked on the border can be pushed either way by the company it keeps."
      },
      {
        "q": "How do you use warm and cool colors in design?",
        "a": "Give one temperature the lead and let the other support it. A mostly cool screen stays calm and recedes, so a single warm accent on the button or the price becomes the spot the eye lands. Warm tones feel near and active, cool tones feel far and quiet, so you can build depth and hierarchy with temperature alone, before you spend any contrast or size."
      }
    ]
  },
  {
    "key": "designing-for-color-blindness",
    "url": "/blog/designing-for-color-blindness",
    "title": "Designing for Color Vision Deficiency",
    "excerpt": "Color blindness, explained for design: the kinds, why red and green get confused, and how to build interfaces everyone can read. Simulate any color live.",
    "date": "2026-06-24",
    "dateLabel": "June 24, 2026",
    "category": "accessibility",
    "categoryLabel": "Accessibility",
    "tags": [
      "color blindness",
      "color vision deficiency",
      "accessibility",
      "contrast",
      "ui design",
      "protanopia",
      "deuteranopia"
    ],
    "readingTimeMinutes": 6,
    "cover": "/assets/blog/designing-for-color-blindness/cover.webp",
    "icon": "/assets/blog/designing-for-color-blindness/icon.svg",
    "coverAccent": "#179FCD",
    "relatedThemes": [],
    "relatedPlatform": "",
    "relatedColor": "00BAFF",
    "relatedPalette": "true",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "warm-and-cool-colors",
      "title": "Warm and Cool Colors",
      "url": "/blog/warm-and-cool-colors",
      "cover": "/assets/blog/warm-and-cool-colors/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-everest-theme",
      "title": "Anatomy of a Light Theme: Everest",
      "url": "/blog/anatomy-of-the-everest-theme",
      "cover": "/assets/blog/anatomy-of-the-everest-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is color blindness?",
        "a": "Color blindness, or color vision deficiency, is when one of the eye's three types of cone cell is missing or shifted, so some colors look the same that look different to most people. It is almost never total. Most people with it see plenty of color, they just confuse certain pairs, most often reds with greens."
      },
      {
        "q": "How common is color blindness?",
        "a": "Common enough that you are designing for it whether you plan to or not. Around one in twelve men and one in two hundred women have some form of color vision deficiency. On a page with a few thousand visitors, hundreds of them are not seeing your reds and greens the way you do."
      },
      {
        "q": "What are the types of color blindness?",
        "a": "There are four families, three named for the affected cone plus the case where color drops out. Protan involves the red (long-wavelength) cone and makes reds look dark and dull; deutan involves the green (medium) cone and is the most common; both cause red-green confusion. Tritan involves the blue (short) cone and confuses blue with yellow, and it is rare. Monochromacy, the rarest, removes color almost entirely, leaving brightness alone. Each family comes in a milder shifted form and a stronger missing-cone form."
      },
      {
        "q": "How do I make a design color-blind friendly?",
        "a": "Never carry meaning with color alone. Pair every color cue with a second signal, a label, an icon, a shape or a pattern, so a red error and a green success are still told apart with the color removed. Keep strong contrast, avoid red-on-green and similar confusing pairs, and check your screens through a simulator before you ship."
      }
    ]
  },
  {
    "key": "anatomy-of-the-everest-theme",
    "url": "/blog/anatomy-of-the-everest-theme",
    "title": "Anatomy of a Light Theme: Everest",
    "excerpt": "Anatomy of Everest, a light IDE theme: layered blue-grey backgrounds, a calm navy foreground, and a cool syntax palette lit by a few warm sparks of dawn.",
    "date": "2026-06-23",
    "dateLabel": "June 23, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "everest",
      "light theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme"
    ],
    "readingTimeMinutes": 6,
    "cover": "/assets/blog/anatomy-of-the-everest-theme/cover.webp",
    "icon": "/assets/themes/nature/everest-theme/icon.webp",
    "coverAccent": "#E4ECEF",
    "relatedThemes": [
      "everest"
    ],
    "relatedPlatform": "",
    "relatedColor": "246A89",
    "relatedPalette": "E4ECEF-1A6D9F-005E79-ED7E5A-8F4446",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "premiumThemes": [
      "sydney"
    ],
    "prev": {
      "key": "designing-for-color-blindness",
      "title": "Designing for Color Vision Deficiency",
      "url": "/blog/designing-for-color-blindness",
      "cover": "/assets/blog/designing-for-color-blindness/cover.webp"
    },
    "next": {
      "key": "anatomy-of-the-aurora-borealis-theme",
      "title": "Anatomy of a Dark Theme: Aurora Borealis",
      "url": "/blog/anatomy-of-the-aurora-borealis-theme",
      "cover": "/assets/blog/anatomy-of-the-aurora-borealis-theme/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Everest theme?",
        "a": "Everest is one of Codigrate's light themes, built around the icy blues and greys of Mount Everest with a few warm accents borrowed from dawn light on the peaks. It pairs a near white editor with a deep navy foreground, so code stays calm and easy to read for long stretches."
      },
      {
        "q": "Why does a good light theme use more than one background color?",
        "a": "Depth. Everest stacks three near neutrals, from the outer surface at #CADAE0 through the window panels up to the near white editor at #FDFEFF. Each panel sits a step lighter than the one behind it, so your eye can tell the toolbar from the editor without any hard borders."
      },
      {
        "q": "How are the syntax colors chosen in Everest?",
        "a": "The structure of the code is painted in cool colors, fir green keywords, teal strings, blue variables and misty grey comments, so the bulk of the screen stays in the mountain's palette. The few warm colors, a brick red for parameters and a rust for annotations, mark the parts that change from call to call, so warmth always means attention."
      },
      {
        "q": "Is a light theme harder on the eyes than a dark one?",
        "a": "Not on its own. What tires eyes is contrast that is too high or too low, not light versus dark. Everest keeps its foreground a deep navy rather than pure black and its background a soft off white rather than glaring white, which lands the contrast in a comfortable range for a full working day."
      }
    ]
  },
  {
    "key": "anatomy-of-the-aurora-borealis-theme",
    "url": "/blog/anatomy-of-the-aurora-borealis-theme",
    "title": "Anatomy of a Dark Theme: Aurora Borealis",
    "excerpt": "Anatomy of Aurora Borealis, a dark IDE theme: a deep blue night backdrop, a soft grey foreground, and syntax in the real colors of the Northern Lights.",
    "date": "2026-06-22",
    "dateLabel": "June 22, 2026",
    "category": "places",
    "categoryLabel": "Inspiration",
    "tags": [
      "aurora borealis",
      "dark theme",
      "syntax highlighting",
      "color palette",
      "theme design",
      "ide theme"
    ],
    "readingTimeMinutes": 5,
    "cover": "/assets/blog/anatomy-of-the-aurora-borealis-theme/cover.webp",
    "icon": "/assets/themes/nature/aurora-borealis-theme/icon.webp",
    "coverAccent": "#7AC6F5",
    "relatedThemes": [
      "aurora-borealis"
    ],
    "relatedPlatform": "",
    "relatedColor": "7AC6F5",
    "relatedPalette": "142B37-7AC6F5-08B9A1-549EFF-73D379-BB719B",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-everest-theme",
      "title": "Anatomy of a Light Theme: Everest",
      "url": "/blog/anatomy-of-the-everest-theme",
      "cover": "/assets/blog/anatomy-of-the-everest-theme/cover.webp"
    },
    "next": {
      "key": "the-color-wheel",
      "title": "Reading the Color Wheel",
      "url": "/blog/the-color-wheel",
      "cover": "/assets/blog/the-color-wheel/cover.webp"
    },
    "faq": [
      {
        "q": "What is the Aurora Borealis theme?",
        "a": "Aurora Borealis is Codigrate's flagship dark theme, built around the deep blues of the Arctic night sky and the green, blue and violet light of the Northern Lights. A near black blue editor sits under a soft grey foreground, with the aurora's own colors carrying the syntax, so it stays calm and easy to read through a long session."
      },
      {
        "q": "Why is the background a deep blue instead of pure black?",
        "a": "Pure black against bright text makes the highest possible contrast, which can buzz and tire the eyes, and it shows smudges and halos on many screens. Aurora uses a deep blue grey instead, around #142B37 for the editor, so the contrast with the soft grey text lands in a comfortable band and the whole screen reads like a night sky rather than a void."
      },
      {
        "q": "How are the syntax colors chosen in Aurora Borealis?",
        "a": "They are the aurora's real colors. Keywords take a magenta, strings a clear blue, functions and globals a Northern Lights green, variables a teal, and comments a quiet lavender. Green, blue and violet are exactly the bands a real aurora glows in, so the code lights up in the same palette as the sky the theme is named for."
      },
      {
        "q": "Is a dark theme better for your eyes?",
        "a": "Neither dark nor light is automatically easier; what matters is landing the contrast in a comfortable range and avoiding glare. A dark theme like Aurora helps most in a dim room, where a bright white page can feel harsh, by keeping the background low and the foreground soft rather than pure white on pure black."
      }
    ]
  },
  {
    "key": "the-color-wheel",
    "url": "/blog/the-color-wheel",
    "title": "Reading the Color Wheel",
    "excerpt": "The color wheel explained: where its circle comes from, why hue is an angle, what the pale hub and slices mean, and how to read relationships off the ring.",
    "date": "2026-06-21",
    "dateLabel": "June 21, 2026",
    "category": "color-theory",
    "categoryLabel": "Color Theory",
    "tags": [
      "color wheel",
      "hue",
      "saturation",
      "hsl",
      "color theory"
    ],
    "readingTimeMinutes": 4,
    "cover": "/assets/blog/the-color-wheel/cover.webp",
    "icon": "/assets/blog/the-color-wheel/icon.svg",
    "coverAccent": "#FF7A18",
    "relatedThemes": [],
    "relatedPlatform": "",
    "relatedColor": "FF7A18",
    "relatedPalette": "true",
    "relatedGradient": "",
    "relatedConverters": [
      "hex-to-hsl",
      "hsl-to-hex"
    ],
    "relatedRepo": "",
    "prev": {
      "key": "anatomy-of-the-aurora-borealis-theme",
      "title": "Anatomy of a Dark Theme: Aurora Borealis",
      "url": "/blog/anatomy-of-the-aurora-borealis-theme",
      "cover": "/assets/blog/anatomy-of-the-aurora-borealis-theme/cover.webp"
    },
    "next": {
      "key": "how-light-makes-colors",
      "title": "How Light Makes Colors",
      "url": "/blog/how-light-makes-colors",
      "cover": "/assets/blog/how-light-makes-colors/cover.webp"
    },
    "faq": [
      {
        "q": "What is the color wheel?",
        "a": "The color wheel is a diagram that arranges every hue in a circle, in the same order light gives them: red, orange, yellow, green, blue, violet. Its job is to turn the question of which colors belong together into something you can read off a position instead of guessing."
      },
      {
        "q": "Why is the color wheel a circle when light is a straight spectrum?",
        "a": "Out in the world the spectrum is a straight line with two ends that never meet, infrared past red and ultraviolet past violet. We bend that line into a ring and close the gap with the magentas and purples your eye only sees when red light and violet light arrive together. The circle is our representation, built so that distance around it becomes meaningful."
      },
      {
        "q": "What does hue mean on the color wheel?",
        "a": "Hue is which color a thing is, before you say anything about how pale or dark it looks. On the wheel hue becomes an angle from 0 to 360 degrees: red sits at 0, green a third of the way round at 120, and blue at 240. The Codigrate color tool labels that exact angle for any color you drop in."
      },
      {
        "q": "Which colors sit opposite each other on the color wheel?",
        "a": "Colors straight across the ring are complementary, and they clash the hardest, which is the high contrast you reach for when one element has to stand out. Colors that sit side by side share a mood because their wavelengths are close, and three spaced evenly around the wheel give you a balanced set."
      }
    ]
  },
  {
    "key": "how-light-makes-colors",
    "url": "/blog/how-light-makes-colors",
    "title": "How Light Makes Colors",
    "excerpt": "Every color is made of light. See how red, green and blue light add up to build any color on a screen, and why screens glow instead of stain like paint.",
    "date": "2026-06-20",
    "dateLabel": "June 20, 2026",
    "category": "color-theory",
    "categoryLabel": "Color Theory",
    "tags": [
      "light",
      "rgb",
      "additive color",
      "screen color"
    ],
    "readingTimeMinutes": 5,
    "cover": "/assets/blog/how-light-makes-colors/cover.webp",
    "icon": "/assets/blog/how-light-makes-colors/icon.svg",
    "coverAccent": "#BAA5FF",
    "relatedThemes": [
      "aurora-borealis"
    ],
    "relatedPlatform": "",
    "relatedColor": "00FF66",
    "relatedPalette": "",
    "relatedGradient": "",
    "relatedConverters": [
      "rgb-to-hex"
    ],
    "relatedRepo": "",
    "prev": {
      "key": "the-color-wheel",
      "title": "Reading the Color Wheel",
      "url": "/blog/the-color-wheel",
      "cover": "/assets/blog/the-color-wheel/cover.webp"
    },
    "next": {
      "key": "harmony-in-opposites",
      "title": "Harmony in Opposites",
      "url": "/blog/harmony-in-opposites",
      "cover": "/assets/blog/harmony-in-opposites/cover.webp"
    },
    "faq": [
      {
        "q": "What is additive color?",
        "a": "Additive color is how a screen makes color: it starts in complete darkness and adds light until it reaches the color you want. Each pixel is three tiny lights, red, green and blue, shining next to each other, and your eye blends them into one color. It is the opposite of mixing paint, which starts white and grows darker."
      },
      {
        "q": "How does a screen make every color from just three lights?",
        "a": "By changing how brightly each light shines. Red and green up together read as yellow, all three at full make white, and none at all is black. Green plus blue gives cyan, red plus blue gives magenta, and every shade in between is those three dials set to different points."
      },
      {
        "q": "What does an RGB value actually mean?",
        "a": "It is the recipe for how bright to make each light: three numbers from 0 to 255, one for red, one for green and one for blue, where 0 means a light is off and 255 means it shines at full strength. Hand a screen that recipe and it reproduces your exact color every time."
      },
      {
        "q": "Why do screens glow instead of stain like paint?",
        "a": "Because a screen gives off light rather than soaking it up. Paint starts on a white page and grows darker as every layer absorbs light, while a screen starts black and grows brighter as every dot adds light. An aurora follows the same additive logic, a dark sky lit up from nothing."
      }
    ]
  },
  {
    "key": "harmony-in-opposites",
    "url": "/blog/harmony-in-opposites",
    "title": "Harmony in Opposites",
    "excerpt": "Complementary color harmony: why opposite colors lift each other, why balance means keeping one small, the split complement, and how to use opposites well.",
    "date": "2026-06-19",
    "dateLabel": "June 19, 2026",
    "category": "palette-harmony",
    "categoryLabel": "Palette & Harmony",
    "tags": [
      "complementary",
      "harmony",
      "split complementary",
      "color harmony",
      "palette",
      "warm and cool"
    ],
    "readingTimeMinutes": 4,
    "cover": "/assets/blog/harmony-in-opposites/cover.webp",
    "icon": "/assets/blog/harmony-in-opposites/icon.svg",
    "coverAccent": "#68c8c8",
    "relatedThemes": [],
    "relatedPlatform": "",
    "relatedColor": "",
    "relatedPalette": "00BAFF-FF6A00",
    "relatedGradient": "00BAFF-FF6A00",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "how-light-makes-colors",
      "title": "How Light Makes Colors",
      "url": "/blog/how-light-makes-colors",
      "cover": "/assets/blog/how-light-makes-colors/cover.webp"
    },
    "next": {
      "key": "introduction-to-readability",
      "title": "Introduction to Readability",
      "url": "/blog/introduction-to-readability",
      "cover": "/assets/blog/introduction-to-readability/cover.webp"
    },
    "faq": [
      {
        "q": "What are complementary colors?",
        "a": "Complementary colors are the pairs that sit directly across the color wheel, like orange and blue or red and green. Every hue has exactly one true opposite, the color you would mix it with to cancel both down to grey."
      },
      {
        "q": "Why do opposite colors look better together?",
        "a": "Set a hue beside its opposite and the eye exaggerates the difference right at the border, an effect called simultaneous contrast. The warm color reads warmer and the cool one cooler, so the pair has real energy. They do not merely tolerate each other, they make each other look better."
      },
      {
        "q": "How do you use complementary colors without them fighting?",
        "a": "Keep one color small. At half and half two opposites start to vibrate, which is tiring to look at. Give one hue most of the room and save its opposite for the few spots where you want the eye to land. Mostly one color with a single opposite accent reads as a deliberate choice."
      },
      {
        "q": "What is split complementary?",
        "a": "A softer opposite. Instead of the exact complement you use the two hues sitting just beside it. You keep most of the warm against cool pull but lose the hard buzz two pure opposites set off where they meet, which is why a lot of calmer themes live there."
      }
    ]
  },
  {
    "key": "introduction-to-readability",
    "url": "/blog/introduction-to-readability",
    "title": "Introduction to Readability",
    "excerpt": "How contrast decides whether text is readable: the WCAG 2 ratio, the APCA Lc score from WCAG 3, and why a color reads differently as ink than as background.",
    "date": "2026-06-18",
    "dateLabel": "June 18, 2026",
    "category": "accessibility",
    "categoryLabel": "Accessibility",
    "tags": [
      "readability",
      "contrast",
      "wcag",
      "apca",
      "accessibility",
      "color theory"
    ],
    "readingTimeMinutes": 4,
    "cover": "/assets/blog/introduction-to-readability/cover.webp",
    "icon": "/assets/blog/introduction-to-readability/icon.svg",
    "coverAccent": "#8BC34A",
    "relatedThemes": [],
    "relatedPlatform": "",
    "relatedColor": "00BAFF",
    "relatedPalette": "",
    "relatedGradient": "",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "harmony-in-opposites",
      "title": "Harmony in Opposites",
      "url": "/blog/harmony-in-opposites",
      "cover": "/assets/blog/harmony-in-opposites/cover.webp"
    },
    "next": {
      "key": "introduction-to-color-harmony",
      "title": "Introduction to Color Harmony",
      "url": "/blog/introduction-to-color-harmony",
      "cover": "/assets/blog/introduction-to-color-harmony/cover.webp"
    },
    "faq": [
      {
        "q": "What is a good contrast ratio for text?",
        "a": "On the WCAG 2 scale, normal body text wants at least 4.5 to 1 to pass AA and 7 to 1 to reach AAA. Large or bold text gets an easier bar of 3 to 1, because bigger shapes stay readable on less contrast. The scale runs from 1 to 1 for no contrast up to 21 to 1 for black on white."
      },
      {
        "q": "What is the difference between WCAG 2 contrast and APCA?",
        "a": "WCAG 2 is a flat luminance ratio that gives the same score no matter which color is the text. APCA, the model heading into WCAG 3, uses a perceptual model tuned to how we actually read and pays attention to which color sits on top, so it returns a direction aware score called Lc."
      },
      {
        "q": "Why does the same color pass on white but fail as text?",
        "a": "Because polarity matters. A light color like Codigrate Blue (#00BAFF) as text on a white page never gives the eye enough edge, so it reads poorly. Flip it around with white text on a #00BAFF button and it reads cleanly. The same two colors give opposite results, which is why you cannot judge a pairing until you know which one is the ink."
      },
      {
        "q": "Which contrast measure should I trust?",
        "a": "Both, side by side. WCAG 2 is the rule most audits and clients still ask for, so it has to pass. APCA is the better read on how text will actually feel, especially in the dark themes we ship most. We check both before a theme goes out."
      }
    ]
  },
  {
    "key": "introduction-to-color-harmony",
    "url": "/blog/introduction-to-color-harmony",
    "title": "Introduction to Color Harmony",
    "excerpt": "Color harmony made simple: analogous, monochrome, complementary, split, triadic and tetradic schemes, why each one works, and a live tool to build your palette.",
    "date": "2026-06-17",
    "dateLabel": "June 17, 2026",
    "category": "palette-harmony",
    "categoryLabel": "Palette & Harmony",
    "tags": [
      "analogous",
      "monochrome",
      "complementary",
      "split complementary",
      "triadic",
      "tetradic",
      "color harmony",
      "palette"
    ],
    "readingTimeMinutes": 6,
    "cover": "/assets/blog/introduction-to-color-harmony/cover.webp",
    "icon": "/assets/blog/introduction-to-color-harmony/icon.svg",
    "coverAccent": "#FA8072",
    "relatedThemes": [],
    "relatedPlatform": "",
    "relatedColor": "00BAFF",
    "relatedPalette": "00BAFF-FFBA00-BA00FF",
    "relatedGradient": "00BAFF-FFBA00-BA00FF",
    "relatedConverters": [],
    "relatedRepo": "",
    "prev": {
      "key": "introduction-to-readability",
      "title": "Introduction to Readability",
      "url": "/blog/introduction-to-readability",
      "cover": "/assets/blog/introduction-to-readability/cover.webp"
    },
    "next": {
      "key": "introduction-to-color-theory",
      "title": "Introduction to Color Theory",
      "url": "/blog/introduction-to-color-theory",
      "cover": "/assets/blog/introduction-to-color-theory/cover.webp"
    },
    "faq": [
      {
        "q": "What is color harmony?",
        "a": "Color harmony is the set of relationships between hues that make them look good together. Instead of guessing, you choose colors at set distances from a base hue: neighbours, opposites, or evenly spaced groups. Those relationships give combinations that almost always work."
      },
      {
        "q": "Which color harmony should I use?",
        "a": "Analogous neighbours feel calm and cohesive, monochrome stays in one hue for the cleanest look, complementary opposites carry the most energy, split complementary softens that opposite, triadic gives a lively balance of three, and tetradic offers the richest range but needs the most restraint. Pick the one whose mood matches your design."
      },
      {
        "q": "Why does my palette look busy even when it follows a scheme?",
        "a": "A scheme tells you which hues agree, not how much of each to use. The fix is proportion: let one color cover most of the surface, a second carry the supporting areas, and a third appear only as an accent. Spend the colors unevenly and even a bold scheme stays calm."
      },
      {
        "q": "What is the difference between complementary and split complementary?",
        "a": "Complementary uses your base and its exact opposite for maximum contrast. Split complementary swaps that single opposite for the two hues sitting on either side of it, so you keep the warm against cool pull but lose the hard vibration two pure opposites set off where they meet."
      }
    ]
  },
  {
    "key": "introduction-to-color-theory",
    "url": "/blog/introduction-to-color-theory",
    "title": "Introduction to Color Theory",
    "excerpt": "A clear, practical guide to the three color models, RGB, HEX, and CMYK. See real values, learn why screens and print differ, and convert any color live.",
    "date": "2026-06-16",
    "dateLabel": "June 16, 2026",
    "category": "color-theory",
    "categoryLabel": "Color Theory",
    "tags": [
      "hex",
      "rgb",
      "cmyk",
      "color theory",
      "color models"
    ],
    "readingTimeMinutes": 5,
    "cover": "/assets/blog/introduction-to-color-theory/cover.webp",
    "icon": "/assets/blog/introduction-to-color-theory/icon.svg",
    "coverAccent": "#f87808",
    "relatedThemes": [],
    "relatedPlatform": "",
    "relatedColor": "549EFF",
    "relatedPalette": "",
    "relatedGradient": "",
    "relatedConverters": [
      "hex-to-rgb",
      "rgb-to-hex"
    ],
    "relatedRepo": "",
    "prev": {
      "key": "introduction-to-color-harmony",
      "title": "Introduction to Color Harmony",
      "url": "/blog/introduction-to-color-harmony",
      "cover": "/assets/blog/introduction-to-color-harmony/cover.webp"
    },
    "next": null,
    "faq": [
      {
        "q": "What is the difference between RGB and HEX?",
        "a": "There is none in the color itself. HEX is just RGB written in base sixteen: the same three values from 0 to 255, packed into six characters behind a hash. #549EFF and rgb(84, 158, 255) are the exact same color in two notations, and HEX is popular because it is compact and copies cleanly into web styling."
      },
      {
        "q": "Why do screen colors look different when printed?",
        "a": "Screens make color by adding light (RGB) while print makes it by subtracting light with ink (CMYK). The two processes are opposites, and ink cannot mix the brightest, most saturated blues and greens a screen can glow, so those colors shift to the nearest printable neighbor and arrive a little flatter on paper."
      },
      {
        "q": "What does the K in CMYK stand for?",
        "a": "Key, the printer's name for black. In theory cyan, magenta and yellow together would make black, but in practice they muddy into a tired brown, so a dedicated black ink does that job more cleanly and cheaply. That is the K channel."
      },
      {
        "q": "How many colors can RGB describe?",
        "a": "A little over sixteen million. Each of the three channels has 256 possible levels from 0 to 255, and 256 to the power of three is roughly 16.7 million, far more than the eye can comfortably tell apart."
      }
    ]
  }
];
